export interface PublicTranslations {
  nav: {
    home: string;
    about: string;
    login: string;
  };
  footer: {
    madeWith: string;
    privacyPolicy: string;
    terms: string;
  };
  landing: {
    title: string;
    tagline: string;
    subtitle: string;
    getStarted: string;
    learnMore: string;
    /** App Store link. Apple's own wording, which their guidelines require. */
    appStore: string;
    workflowTitle: string;
    workflowSubtitle: string;
    workflow: {
      save: { step: string; title: string; description: string };
      tag: { step: string; title: string; description: string };
      find: { step: string; title: string; description: string };
      connect: { step: string; title: string; description: string };
      reuse: { step: string; title: string; description: string };
    };
    painTitle: string;
    pains: {
      screenshots: { hook: string; answer: string };
      arguments: { hook: string; answer: string };
      scattered: { hook: string; answer: string };
      connections: { hook: string; answer: string };
      video: { hook: string; answer: string };
      prompts: { hook: string; answer: string };
      draft: { hook: string; answer: string };
    };
    featuresTitle: string;
    comingSoonBadge: string;
    featuresSubtitle: string;
    features: {
      brain: { title: string; description: string };
      web: { title: string; description: string };
      recall: { title: string; description: string };
      organization: { title: string; description: string };
      video: { title: string; description: string; comingSoon?: boolean };
      documents: { title: string; description: string };
      versions: { title: string; description: string };
      storyboards: { title: string; description: string };
      scriptToStoryboard: { title: string; description: string };
      wordFinder: { title: string; description: string };
    };
    audienceTitle: string;
    audiences: {
      creators: { title: string; description: string };
      journalists: { title: string; description: string };
      writers: { title: string; description: string };
      researchers: { title: string; description: string };
      social: { title: string; description: string };
      legal: { title: string; description: string };
      developers: { title: string; description: string };
      designers: { title: string; description: string };
    };
    ctaTitle: string;
    ctaSubtitle: string;
    ctaButton: string;
  };
  about: {
    title: string;
    tagline: string;
    storyTitle: string;
    storyP1: string;
    storyP2: string;
    techTitle: string;
    techIntro: string;
    techFeatures: {
      ocr: string;
      aiTagging: string;
      videoSummaries: string;
      mindMapping: string;
      search: string;
    };
    privacyTitle: string;
    sections: {
      infoCollect: string;
      howWeUse: string;
      dataSecurity: string;
      dataSharing: string;
      yourRights: string;
      dataRetention: string;
      children: string;
      international: string;
      changes: string;
      contact: string;
    };
    effectiveDate: string;
    termsLinkText: string;
    puraVida: string;
    privPersonalTitle: string;
    privPersonal1: string;
    privPersonal2: string;
    privPersonal3: string;
    privPersonal4: string;
    privAutoTitle: string;
    privAuto1: string;
    privAuto2: string;
    privAuto3: string;
    privUse1: string;
    privUse2: string;
    privUse3: string;
    privUse4: string;
    privUse5: string;
    privUse6: string;
    privSecurityBody: string;
    privSecurityThirdParty: string;
    privSharingIntro: string;
    privSharing1: string;
    privSharing2: string;
    privSharing3: string;
    privSharing4: string;
    privSharing5: string;
    privAccessTitle: string;
    privAccess1: string;
    privAccess2: string;
    privAccess3: string;
    privAccess4: string;
    privCommTitle: string;
    privComm1: string;
    privComm2: string;
    privRegionalTitle: string;
    privRegional1: string;
    privRegional2: string;
    privRegional3: string;
    privRetentionBody: string;
    privChildrenBody: string;
    privInternationalBody: string;
    privChangesBody: string;
    privContactIntro: string;
    privContactEmail: string;
    privContactLocation: string;
  };
  terms: {
    title: string;
    tagline: string;
    effectiveDate: string;
    lastUpdated: string;
    sections: {
      acceptance: string;
      description: string;
      accounts: string;
      content: string;
      acceptableUse: string;
      payment: string;
      privacy: string;
      disclaimers: string;
      indemnification: string;
      thirdParty: string;
      copyright: string;
      disputes: string;
      governing: string;
      modifications: string;
      severability: string;
      entire: string;
      contact: string;
      euProvisions: string;
    };
    acknowledgment: string;
    effectiveDateValue: string;
    lastUpdatedValue: string;
    intro: string;
    acceptanceIntro: string;
    acceptance1: string;
    acceptance2: string;
    acceptance3: string;
    acceptance4: string;
    descriptionIntro: string;
    description1: string;
    description2: string;
    description3: string;
    description4: string;
    description5: string;
    description6: string;
    descriptionOutro: string;
    accountsCreationTitle: string;
    accountsCreationIntro: string;
    accountsCreation1: string;
    accountsCreation2: string;
    accountsCreation3: string;
    accountsCreation4: string;
    accountsCreation5: string;
    accountsTerminationTitle: string;
    accountsTerminationBody: string;
    contentYoursTitle: string;
    contentYoursIntro: string;
    contentYours1: string;
    contentYours2: string;
    contentYours3: string;
    contentYoursOutro: string;
    contentResponsibilityTitle: string;
    contentResponsibilityIntro: string;
    contentResponsibility1: string;
    contentResponsibility2: string;
    contentResponsibility3: string;
    contentProhibitedTitle: string;
    contentProhibitedIntro: string;
    contentProhibited1: string;
    contentProhibited2: string;
    contentProhibited3: string;
    contentProhibited4: string;
    contentProhibited5: string;
    contentProhibited6: string;
    contentProhibited7: string;
    contentOurRightsTitle: string;
    contentOurRightsBody: string;
    acceptableUseIntro: string;
    acceptableUse1: string;
    acceptableUse2: string;
    acceptableUse3: string;
    acceptableUse4: string;
    acceptableUse5: string;
    acceptableUse6: string;
    acceptableUse7: string;
    acceptableUse8: string;
    acceptableUse9: string;
    acceptableUse10: string;
    paymentPricingTitle: string;
    paymentPricingBody: string;
    paymentBillingTitle: string;
    paymentBillingIntro: string;
    paymentBilling1: string;
    paymentBilling2: string;
    paymentBilling3: string;
    paymentBilling4: string;
    paymentCancellationTitle: string;
    paymentCancellationBody: string;
    privacyBody: string;
    privacyGdpr: string;
    disclaimersAsIsTitle: string;
    disclaimersAsIsBody: string;
    disclaimersNoWarrantyIntro: string;
    disclaimersNoWarranty1: string;
    disclaimersNoWarranty2: string;
    disclaimersNoWarranty3: string;
    disclaimersNoWarranty4: string;
    disclaimersLiabilityTitle: string;
    disclaimersLiabilityP1: string;
    disclaimersLiabilityP2: string;
    disclaimersBackupTitle: string;
    disclaimersBackupBody: string;
    indemnificationIntro: string;
    indemnification1: string;
    indemnification2: string;
    indemnification3: string;
    indemnification4: string;
    thirdPartyBody: string;
    copyrightIntro: string;
    copyright1: string;
    copyright2: string;
    copyright3: string;
    copyright4: string;
    copyright5: string;
    copyright6: string;
    copyrightOutro: string;
    disputesInformalTitle: string;
    disputesInformalBody: string;
    disputesArbitrationTitle: string;
    disputesArbitrationBody: string;
    disputesEuTitle: string;
    disputesEuBody: string;
    disputesClassActionTitle: string;
    disputesClassActionBody: string;
    governingBody: string;
    modificationsP1: string;
    modificationsP2: string;
    severabilityBody: string;
    entireBody: string;
    contactIntro: string;
    contactEmail: string;
    contactSupport: string;
    contactLocation: string;
    euIntro: string;
    euWithdrawal: string;
    euGuarantees: string;
    euUnfair: string;
    euDataProtection: string;
  };
  // The logged-out sign-in, registration and app hand-off screens
  auth: {
    loginTitle: string;
    emailLabel: string;
    passwordLabel: string;
    loggingIn: string;
    loginButton: string;
    invalidCredentials: string;
    noAccount: string;
    registerHere: string;
    registerTitle: string;
    emailField: string;
    passwordField: string;
    confirmPasswordField: string;
    usernameOptional: string;
    registering: string;
    registerButton: string;
    haveAccount: string;
    loginHere: string;
    invalidEmail: string;
    passwordsDoNotMatch: string;
    passwordTooShort: string;
    /** Server-side field errors, e.g. "Email: that address is taken". */
    emailErrorPrefix: string;
    passwordErrorPrefix: string;
    registrationFailed: string;
    /** The divider above Google's button; the button's own label is Google's. */
    orDivider: string;
    googleLoadFailed: string;
    googleSignInFailed: string;
    handoffMissingCode: string;
    handoffInvalid: string;
    handoffFailedTitle: string;
    handoffLogIn: string;
    handoffSigningIn: string;
  };
}

export const translations: Record<string, PublicTranslations> = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      login: 'Login',
    },
    footer: {
      madeWith: 'Made with \u2764\ufe0f in Costa Rica \ud83c\udde8\ud83c\uddf7',
      privacyPolicy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    landing: {
      title: 'Yarnboard',
      tagline: 'Never lose a useful idea again.',
      subtitle: 'Save thoughts, screenshots, arguments, and memes into a searchable memory you can actually reuse.',
      getStarted: 'Start Free',
      learnMore: 'See How It Works',
      appStore: 'Download on the App Store',
      workflowTitle: 'How it works',
      workflowSubtitle: 'Five steps. That\'s it.',
      workflow: {
        save: {
          step: '1',
          title: 'Save anything',
          description: 'A screenshot, a quote, a meme, an argument you spent 20 minutes writing. Paste it in.',
        },
        tag: {
          step: '2',
          title: 'Tag it',
          description: 'Add a few tags. AI suggests them for you. No tag, no entry \u2014 so nothing gets lost in the void.',
        },
        find: {
          step: '3',
          title: 'Find it instantly',
          description: 'Search by a few letters. By tag. By what the text in a screenshot said. It\'s all searchable.',
        },
        connect: {
          step: '4',
          title: 'See the threads',
          description: 'Shared tags string your notes together. Discovery pulls the yarn between ideas you never thought to connect — that\'s the board this app is named after.',
        },
        reuse: {
          step: '5',
          title: 'Reuse it',
          description: 'Click to copy. Paste into a conversation, a doc, a post. The perfect response, ready when you need it.',
        },
      },
      painTitle: 'Sound familiar?',
      pains: {
        screenshots: {
          hook: '"I have thousands of screenshots and can\'t find anything."',
          answer: 'OCR reads the text in your images. Search by what the screenshot says, not what you named the file.',
        },
        arguments: {
          hook: '"I wrote the perfect response once. Now I can\'t find it."',
          answer: 'Save it, tag it, search it. Next time the topic comes up, one click and it\'s in your clipboard.',
        },
        scattered: {
          hook: '"My ideas are in 5 different apps and none of them talk to each other."',
          answer: 'One place. Text, images, links, videos. All tagged, all searchable, all connected.',
        },
        connections: {
          hook: '"I know these ideas are related but I can\'t see how."',
          answer: 'Discover surfaces notes you saved months apart that share rare tags \u2014 connections you didn\'t know you had.',
        },
        video: {
          hook: '"I watched a great video but can\'t remember which one said that thing."',
          answer: 'Save the link and press Summarize. Every major point the video made lands in the note as text, so searching for the point finds the video.',
        },
        prompts: {
          hook: '"I keep rewriting the same prompts and templates from scratch."',
          answer: 'Save your best prompts, email templates, and canned responses. Search, click, paste.',
        },
        draft: {
          hook: '"My research is in one app and my draft is in another."',
          answer: 'Write the draft where the research already lives. Every note, screenshot and source you saved is one search away in the same app \u2014 not in a tab you have to go and find.',
        },
      },
      featuresTitle: 'What\'s inside',
      comingSoonBadge: 'Coming soon',
      featuresSubtitle: 'Everything you need to capture, organize, and reuse your best thinking.',
      features: {
        brain: {
          title: 'Your External Brain',
          description: 'Store every meme, screenshot, article, and thought. OCR reads text from images so nothing is ever lost.',
        },
        web: {
          title: 'Discover Connections',
          description: 'See which of your ideas are secretly related. Rare shared tags surface surprising connections.',
        },
        recall: {
          title: 'Instant Recall',
          description: 'Search with a few letters and find anything. That quote? That link? That perfect comeback? Right here.',
        },
        organization: {
          title: 'Smart Organization',
          description: 'AI tagging keeps everything organized, and a picture with no caption is no obstacle: Yarnboard reads the words inside it and tags the screenshot by what it actually says. No tag, no entry \u2014 we keep you disciplined.',
        },
        video: {
          title: 'Video Summaries',
          description: 'Save a YouTube link and press one button. Every major point the video made becomes note text you can search, edit, and reuse.',
        },
        documents: {
          title: 'Documents Fed By Your Notes',
          description: 'A full writing editor that knows where your material is. Pull saved notes straight into the draft, split, merge and reorganize \u2014 the research and the writing in one place instead of two.',
        },
        versions: {
          title: 'Nothing Is One Save Away',
          description: 'Your documents keep their last 15 versions as you write, and a checkpoint is taken the moment a lot of text disappears. Delete a chapter by accident and it comes back with one button \u2014 on the free plan too.',
        },
        storyboards: {
          title: 'Visual Storyboards',
          description: 'Arrange your notes like a detective\'s evidence board. Drag, drop, and sequence your ideas into narratives.',
        },
        scriptToStoryboard: {
          title: 'Script to Storyboard',
          description: 'Transform scripts into visual storyboards instantly. A head start on production planning.',
        },
        wordFinder: {
          title: 'Find Your Words',
          description: 'Lost the perfect word? Search by context and meaning. Fill in the blanks with exactly what you meant to say.',
        },
      },
      audienceTitle: 'People who get it',
      audiences: {
        creators: {
          title: 'Content Creators',
          description: 'YouTubers, filmmakers, documentarians tracking sources and building narratives',
        },
        journalists: {
          title: 'Journalists',
          description: 'Investigative reporters managing sources across multiple rabbit holes',
        },
        writers: {
          title: 'Writers & Authors',
          description: 'Building worlds, tracking characters, never losing that perfect line',
        },
        researchers: {
          title: 'Researchers',
          description: 'Academics and students managing citations and research materials',
        },
        social: {
          title: 'Social Media Pros',
          description: 'Influencers and strategists who need instant access to saved content',
        },
        legal: {
          title: 'Legal & Education',
          description: 'Lawyers tracking evidence, educators building curricula',
        },
        developers: {
          title: 'Software Developers',
          description: 'Capturing feature ideas, tracking bugs, and designing application flows',
        },
        designers: {
          title: 'Designers',
          description: 'Curating visual inspiration like a personal Pinterest',
        },
      },
      ctaTitle: 'Your best ideas deserve better than a forgotten screenshot.',
      ctaSubtitle: 'Free to start. No credit card required.',
      ctaButton: 'Get Started',
    },
    about: {
      title: 'About Yarnboard',
      tagline: 'Crafted with Pura Vida in Costa Rica \ud83c\udde8\ud83c\uddf7',
      storyTitle: 'Our Story',
      storyP1: 'Yarnboard was born from a simple frustration: losing track of brilliant thoughts, important links, and that perfect meme at just the wrong moment. We believed there had to be a better way to capture, organize, and connect the endless stream of information flowing through our digital lives.',
      storyP2: 'Built with love in the beautiful mountains of Costa Rica, Yarnboard combines the creative spirit of Pura Vida with cutting-edge technology to create your personal knowledge management system. Whether you\'re a content creator tracking sources, a researcher managing citations, or just someone who refuses to lose another great idea\u2014Yarnboard is your digital conspiracy wall.',
      techTitle: 'Built on Modern Technology',
      techIntro: 'Yarnboard leverages state-of-the-art AI and machine learning to make your information work for you:',
      techFeatures: {
        ocr: 'OCR Technology: Automatically extracts text from images so every screenshot is searchable',
        aiTagging: 'AI-Powered Tagging: Smart suggestions help you organize without thinking',
        videoSummaries: 'Video Summaries: Turns a YouTube link into the video\'s major points as searchable note text',
        mindMapping: 'Visual Mind Mapping: Automatically discovers connections between your notes',
        search: 'Full-Text Search: Find anything with just a few keystrokes',
      },
      privacyTitle: 'Privacy Policy',
      sections: {
        infoCollect: '1. Information We Collect',
        howWeUse: '2. How We Use Your Information',
        dataSecurity: '3. Data Storage and Security',
        dataSharing: '4. Data Sharing and Disclosure',
        yourRights: '5. Your Rights and Choices',
        dataRetention: '6. Data Retention',
        children: '7. Children\'s Privacy',
        international: '8. International Data Transfers',
        changes: '9. Changes to This Policy',
        contact: '10. Contact Us',
      },
      effectiveDate: 'Effective Date: January 2025',
      termsLinkText: 'For complete legal terms, please review our',
      puraVida: 'Pura Vida!',
      privPersonalTitle: '**Personal Information:**',
      privPersonal1: 'Account information (email address, username, password)',
      privPersonal2: 'Content you create (notes, documents, tags, links)',
      privPersonal3: 'Media files (images, videos) you upload to the service',
      privPersonal4: 'Usage data (search queries, feature interactions, timestamps)',
      privAutoTitle: '**Automatically Collected Information:**',
      privAuto1: 'Device information (browser type, operating system)',
      privAuto2: 'IP address and general location data',
      privAuto3: 'Cookies and similar tracking technologies',
      privUse1: '**Service Delivery:** To provide, maintain, and improve Yarnboard\'s features',
      privUse2: '**AI Processing:** To perform OCR, transcription, tagging, and search functionality',
      privUse3: '**Account Management:** To authenticate you and manage your account',
      privUse4: '**Communication:** To send service updates and respond to your inquiries',
      privUse5: '**Analytics:** To understand usage patterns and improve the platform',
      privUse6: '**Security:** To protect against fraud, abuse, and security threats',
      privSecurityBody: 'Your data is stored securely on servers located in the United States. We use industry-standard encryption for data in transit (HTTPS/TLS) and at rest. We implement appropriate technical and organizational measures to protect your information from unauthorized access, disclosure, alteration, and destruction.',
      privSecurityThirdParty: '**Third-Party Services:** We use trusted cloud infrastructure providers (AWS) for storage and processing. These providers have their own security certifications and comply with international data protection standards.',
      privSharingIntro: 'We do not sell your personal information. We may share data only in these circumstances:',
      privSharing1: '**With Your Consent:** When you explicitly authorize us to share information',
      privSharing2: '**Service Providers:** With vendors who help us operate the platform (cloud hosting, analytics)',
      privSharing3: '**Legal Obligations:** When required by law, court order, or government request',
      privSharing4: '**Business Transfers:** In connection with a merger, acquisition, or sale of assets',
      privSharing5: '**Protection:** To protect rights, property, or safety of Yarnboard, users, or the public',
      privAccessTitle: '**Access and Control:**',
      privAccess1: 'Access, download, or delete your data at any time through your account settings',
      privAccess2: 'Modify or correct your personal information',
      privAccess3: 'Export all your content in a portable format',
      privAccess4: 'Delete your account and all associated data',
      privCommTitle: '**Communication Preferences:**',
      privComm1: 'Opt out of marketing communications (service-related emails will continue)',
      privComm2: 'Control cookie preferences through your browser settings',
      privRegionalTitle: '**Regional Rights:**',
      privRegional1: '**GDPR (EU):** Right to access, rectification, erasure, data portability, and objection',
      privRegional2: '**CCPA (California):** Right to know, delete, and opt-out of data sales',
      privRegional3: '**Other Jurisdictions:** Rights as provided by applicable local laws',
      privRetentionBody: 'We retain your information for as long as your account is active or as needed to provide services. When you delete content or your account, we remove it from active systems within 30 days, though backup copies may persist for up to 90 days for disaster recovery purposes.',
      privChildrenBody: 'Yarnboard is not intended for users under 13 years of age. We do not knowingly collect personal information from children. If we become aware that a child has provided us with personal information, we will take steps to delete such information.',
      privInternationalBody: 'If you access Yarnboard from outside Costa Rica or the United States, your information may be transferred to and processed in countries with different data protection laws. By using our service, you consent to such transfers.',
      privChangesBody: 'We may update this Privacy Policy from time to time. We will notify you of significant changes by email or through the service. Continued use of Yarnboard after changes indicates acceptance of the updated policy.',
      privContactIntro: 'For questions about this Privacy Policy or our data practices, please contact us:',
      privContactEmail: '**Email:** privacy@yarnboard.com',
      privContactLocation: '**Location:** Costa Rica',
    },
    terms: {
      title: 'Terms of Service',
      tagline: 'Yarnboard',
      effectiveDate: 'Effective Date:',
      lastUpdated: 'Last Updated:',
      sections: {
        acceptance: '1. Acceptance of Terms',
        description: '2. Description of Service',
        accounts: '3. User Accounts and Security',
        content: '4. User Content and Intellectual Property',
        acceptableUse: '5. Acceptable Use',
        payment: '6. Payment and Subscriptions',
        privacy: '7. Privacy and Data Protection',
        disclaimers: '8. Disclaimers and Limitations of Liability',
        indemnification: '9. Indemnification',
        thirdParty: '10. Third-Party Services',
        copyright: '11. Copyright and DMCA',
        disputes: '12. Dispute Resolution and Arbitration',
        governing: '13. Governing Law and Jurisdiction',
        modifications: '14. Modifications to Terms',
        severability: '15. Severability and Waiver',
        entire: '16. Entire Agreement',
        contact: '17. Contact Information',
        euProvisions: '18. Special Provisions for EU Users',
      },
      acknowledgment: 'BY USING YARNBOARD, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS OF SERVICE.',
      effectiveDateValue: 'January 1, 2025',
      lastUpdatedValue: 'January 1, 2025',
      intro: 'Welcome to Yarnboard. These Terms of Service ("Terms") govern your access to and use of Yarnboard\'s services, website, and applications (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree to these Terms, you may not use the Service.',
      acceptanceIntro: 'By creating an account or using Yarnboard, you confirm that:',
      acceptance1: 'You are at least 13 years of age (or the minimum age required in your jurisdiction)',
      acceptance2: 'You have the legal capacity to enter into a binding agreement',
      acceptance3: 'You will comply with these Terms and all applicable laws and regulations',
      acceptance4: 'All information you provide is accurate and up-to-date',
      descriptionIntro: 'Yarnboard is a digital knowledge management platform that allows users to:',
      description1: 'Create, store, and organize notes, documents, and media content',
      description2: 'Upload and process images with optical character recognition (OCR)',
      description3: 'Transcribe audio and video content',
      description4: 'Create visual mind maps and connections between content',
      description5: 'Search and retrieve stored information',
      description6: 'Utilize AI-powered features for organization and tagging',
      descriptionOutro: 'We reserve the right to modify, suspend, or discontinue any aspect of the Service at any time, with or without notice, and without liability to you.',
      accountsCreationTitle: '3.1 Account Creation',
      accountsCreationIntro: 'To use certain features of the Service, you must create an account. You agree to:',
      accountsCreation1: 'Provide accurate and complete registration information',
      accountsCreation2: 'Maintain and promptly update your account information',
      accountsCreation3: 'Keep your password secure and confidential',
      accountsCreation4: 'Notify us immediately of any unauthorized access or security breach',
      accountsCreation5: 'Accept responsibility for all activities under your account',
      accountsTerminationTitle: '3.2 Account Termination',
      accountsTerminationBody: 'You may terminate your account at any time through the account settings. We reserve the right to suspend or terminate your account if you violate these Terms, engage in fraudulent activity, or for any other reason at our sole discretion.',
      contentYoursTitle: '4.1 Your Content',
      contentYoursIntro: 'You retain all ownership rights to the content you create, upload, or store on Yarnboard ("User Content"). By using the Service, you grant Yarnboard a worldwide, non-exclusive, royalty-free license to:',
      contentYours1: 'Store, process, and transmit your User Content to provide the Service',
      contentYours2: 'Perform OCR, transcription, and AI analysis on your User Content',
      contentYours3: 'Create backups and derivative formats necessary for Service operation',
      contentYoursOutro: 'This license terminates when you delete your content or account, except for content shared with other users or as required by law.',
      contentResponsibilityTitle: '4.2 Content Responsibility',
      contentResponsibilityIntro: 'You are solely responsible for your User Content. You represent and warrant that:',
      contentResponsibility1: 'You own or have the necessary rights to all User Content you upload',
      contentResponsibility2: 'Your User Content does not violate any third-party rights (copyright, trademark, privacy, etc.)',
      contentResponsibility3: 'Your User Content complies with these Terms and applicable laws',
      contentProhibitedTitle: '4.3 Prohibited Content',
      contentProhibitedIntro: 'You may not upload, store, or share content that:',
      contentProhibited1: 'Is illegal, harmful, threatening, abusive, harassing, defamatory, or hateful',
      contentProhibited2: 'Infringes on intellectual property rights or other proprietary rights',
      contentProhibited3: 'Contains malware, viruses, or other harmful code',
      contentProhibited4: 'Violates privacy rights or contains unauthorized personal information',
      contentProhibited5: 'Promotes illegal activities or violence',
      contentProhibited6: 'Contains child sexual abuse material or exploits minors',
      contentProhibited7: 'Constitutes spam or unsolicited commercial content',
      contentOurRightsTitle: '4.4 Our Rights',
      contentOurRightsBody: 'Yarnboard and its licensors retain all rights, title, and interest in the Service, including all software, technology, designs, and trademarks. These Terms do not grant you any rights to use Yarnboard\'s intellectual property except as necessary to use the Service.',
      acceptableUseIntro: 'You agree not to:',
      acceptableUse1: 'Use the Service for any illegal purpose or in violation of any laws',
      acceptableUse2: 'Attempt to gain unauthorized access to the Service or other users\' accounts',
      acceptableUse3: 'Interfere with or disrupt the Service or servers',
      acceptableUse4: 'Use automated systems (bots, scrapers) without permission',
      acceptableUse5: 'Reverse engineer, decompile, or disassemble any part of the Service',
      acceptableUse6: 'Remove or modify any copyright, trademark, or proprietary notices',
      acceptableUse7: 'Impersonate any person or entity or misrepresent your affiliation',
      acceptableUse8: 'Collect or harvest information about other users',
      acceptableUse9: 'Use the Service to send spam or unsolicited messages',
      acceptableUse10: 'Overload or attempt to overwhelm our infrastructure',
      paymentPricingTitle: '6.1 Pricing',
      paymentPricingBody: 'Certain features or tiers of the Service may require payment. All fees are in U.S. dollars unless otherwise stated. We reserve the right to change our pricing with 30 days\' notice.',
      paymentBillingTitle: '6.2 Billing',
      paymentBillingIntro: 'If you purchase a subscription:',
      paymentBilling1: 'You authorize us to charge your payment method on a recurring basis',
      paymentBilling2: 'Subscriptions automatically renew unless canceled before the renewal date',
      paymentBilling3: 'You are responsible for all charges incurred under your account',
      paymentBilling4: 'Refunds are provided only as required by law or at our discretion',
      paymentCancellationTitle: '6.3 Cancellation',
      paymentCancellationBody: 'You may cancel your subscription at any time through account settings. Cancellation takes effect at the end of the current billing period. No partial refunds are provided for unused time.',
      privacyBody: 'Your use of the Service is subject to our Privacy Policy, which explains how we collect, use, and protect your personal information. By using the Service, you consent to our data practices as described in the Privacy Policy.',
      privacyGdpr: '**GDPR Compliance:** For users in the European Union, we comply with the General Data Protection Regulation (GDPR). You have rights to access, rectification, erasure, data portability, and objection regarding your personal data.',
      disclaimersAsIsTitle: '8.1 Service "As Is"',
      disclaimersAsIsBody: 'THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR ACCURACY.',
      disclaimersNoWarrantyIntro: 'We do not warrant that:',
      disclaimersNoWarranty1: 'The Service will be uninterrupted, secure, or error-free',
      disclaimersNoWarranty2: 'Content will be accurate, complete, or reliable',
      disclaimersNoWarranty3: 'Defects will be corrected',
      disclaimersNoWarranty4: 'The Service is free from viruses or harmful components',
      disclaimersLiabilityTitle: '8.2 Limitation of Liability',
      disclaimersLiabilityP1: 'TO THE MAXIMUM EXTENT PERMITTED BY LAW, YARNBOARD SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF DATA, LOSS OF PROFITS, OR BUSINESS INTERRUPTION, ARISING OUT OF OR RELATED TO YOUR USE OR INABILITY TO USE THE SERVICE.',
      disclaimersLiabilityP2: 'IN JURISDICTIONS THAT DO NOT ALLOW LIMITATION OF LIABILITY, OUR LIABILITY IS LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW. IN NO EVENT SHALL OUR TOTAL LIABILITY EXCEED THE AMOUNT YOU PAID TO US IN THE 12 MONTHS PRECEDING THE CLAIM, OR $100, WHICHEVER IS GREATER.',
      disclaimersBackupTitle: '8.3 Backup Responsibility',
      disclaimersBackupBody: 'While we implement backup systems, you are responsible for maintaining your own backups of important content. We are not liable for any loss or corruption of your data.',
      indemnificationIntro: 'You agree to indemnify, defend, and hold harmless Yarnboard, its officers, directors, employees, and agents from any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorneys\' fees) arising out of:',
      indemnification1: 'Your use or misuse of the Service',
      indemnification2: 'Your violation of these Terms',
      indemnification3: 'Your violation of any third-party rights',
      indemnification4: 'Your User Content',
      thirdPartyBody: 'The Service may integrate with or link to third-party services, websites, or content. We do not control and are not responsible for third-party services. Your use of third-party services is at your own risk and subject to their terms and policies.',
      copyrightIntro: 'We respect intellectual property rights. If you believe content on Yarnboard infringes your copyright, please contact us with:',
      copyright1: 'Identification of the copyrighted work',
      copyright2: 'Identification of the infringing material and its location',
      copyright3: 'Your contact information',
      copyright4: 'A statement of good faith belief that use is unauthorized',
      copyright5: 'A statement that the information is accurate and you are authorized to act',
      copyright6: 'Your physical or electronic signature',
      copyrightOutro: 'We will respond to valid DMCA notices and may terminate accounts of repeat infringers.',
      disputesInformalTitle: '12.1 Informal Resolution',
      disputesInformalBody: 'Before initiating formal proceedings, you agree to contact us to attempt informal resolution of any dispute.',
      disputesArbitrationTitle: '12.2 Arbitration (U.S. Users)',
      disputesArbitrationBody: 'For users in the United States, any dispute arising from these Terms or the Service shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association, except where prohibited by law.',
      disputesEuTitle: '12.3 EU Users',
      disputesEuBody: 'For users in the European Union, disputes may be submitted to the competent courts in your country of residence. EU consumers may also use the European Commission\'s Online Dispute Resolution platform at: https://ec.europa.eu/consumers/odr',
      disputesClassActionTitle: '12.4 Class Action Waiver',
      disputesClassActionBody: 'To the extent permitted by law, you agree that disputes will be resolved individually, and you waive the right to participate in class actions or class-wide arbitration.',
      governingBody: 'These Terms are governed by the laws of Costa Rica, without regard to conflict of law principles. For EU users, mandatory consumer protection laws of your country of residence shall apply where applicable.',
      modificationsP1: 'We may modify these Terms at any time by posting the updated Terms on our website. Material changes will be notified via email or through the Service at least 30 days before taking effect. Continued use after changes constitutes acceptance of the modified Terms.',
      modificationsP2: 'If you do not agree to modified Terms, you must stop using the Service and may terminate your account.',
      severabilityBody: 'If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full effect. Our failure to enforce any right or provision does not constitute a waiver of that right or provision.',
      entireBody: 'These Terms, together with our Privacy Policy, constitute the entire agreement between you and Yarnboard regarding the Service and supersede all prior agreements and understandings.',
      contactIntro: 'For questions about these Terms or the Service, please contact us:',
      contactEmail: '**Email:** legal@yarnboard.com',
      contactSupport: '**Support:** support@yarnboard.com',
      contactLocation: '**Location:** Costa Rica',
      euIntro: 'In addition to the above terms, the following provisions apply to users in the European Union:',
      euWithdrawal: '**Right of Withdrawal:** You have 14 days to withdraw from a purchase without giving a reason',
      euGuarantees: '**Consumer Guarantees:** Digital content must be as described and fit for purpose',
      euUnfair: '**Unfair Terms:** Any unfair contract terms are not binding on EU consumers',
      euDataProtection: '**Data Protection:** Your rights under GDPR cannot be waived by these Terms',
    },
    auth: {
      loginTitle: 'Login',
      emailLabel: 'Email:',
      passwordLabel: 'Password:',
      loggingIn: 'Logging in...',
      loginButton: 'Login',
      invalidCredentials: 'Invalid username or password',
      noAccount: 'Don\'t have an account? ',
      registerHere: 'Register here',
      registerTitle: 'Register',
      emailField: 'Email',
      passwordField: 'Password',
      confirmPasswordField: 'Confirm Password',
      usernameOptional: 'Username (optional)',
      registering: 'Registering...',
      registerButton: 'Register',
      haveAccount: 'Already have an account? ',
      loginHere: 'Login here',
      invalidEmail: 'Please enter a valid email address',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      emailErrorPrefix: 'Email: {message}',
      passwordErrorPrefix: 'Password: {message}',
      registrationFailed: 'Registration failed. Please try again.',
      orDivider: 'or',
      googleLoadFailed: 'Failed to load Google sign-in',
      googleSignInFailed: 'Google sign-in failed',
      handoffMissingCode: 'This sign-in link is missing its code.',
      handoffInvalid: 'This sign-in link is invalid or has expired. Please try again from the app.',
      handoffFailedTitle: 'Couldn\u2019t sign you in',
      handoffLogIn: 'Log in',
      handoffSigningIn: 'Signing you in\u2026',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Acerca de',
      login: 'Iniciar Sesi\u00f3n',
    },
    footer: {
      madeWith: 'Hecho con \u2764\ufe0f en Costa Rica \ud83c\udde8\ud83c\uddf7',
      privacyPolicy: 'Pol\u00edtica de Privacidad',
      terms: 'T\u00e9rminos de Servicio',
    },
    landing: {
      title: 'Yarnboard',
      tagline: 'Nunca pierdas una buena idea.',
      subtitle: 'Guarda pensamientos, capturas, argumentos y memes en una memoria buscable que realmente puedes reutilizar.',
      getStarted: 'Empezar Gratis',
      learnMore: 'Ver C\u00f3mo Funciona',
      appStore: 'Cons\u00edguelo en el App Store',
      workflowTitle: 'C\u00f3mo funciona',
      workflowSubtitle: 'Cinco pasos. Eso es todo.',
      workflow: {
        save: {
          step: '1',
          title: 'Guarda lo que sea',
          description: 'Una captura, una cita, un meme, un argumento que te tom\u00f3 20 minutos escribir. P\u00e9galo.',
        },
        tag: {
          step: '2',
          title: 'Etiq\u00faetalo',
          description: 'Agrega unas etiquetas. La IA te las sugiere. Sin etiqueta no hay entrada \u2014 nada se pierde en el vac\u00edo.',
        },
        find: {
          step: '3',
          title: 'Encont\u00e1 al instante',
          description: 'Busc\u00e1 con unas letras. Por etiqueta. Por lo que dec\u00eda el texto en una captura. Todo es buscable.',
        },
        connect: {
          step: '4',
          title: 'Ve los hilos',
          description: 'Las etiquetas compartidas hilan tus notas entre s\u00ed. Descubrimiento tira del hilo entre ideas que nunca pensaste conectar \u2014 ese es el tablero que le da nombre a esta app.',
        },
        reuse: {
          step: '5',
          title: 'Reutilizalo',
          description: 'Clic para copiar. Peg\u00e1 en una conversaci\u00f3n, un doc, un post. La respuesta perfecta, lista cuando la necesites.',
        },
      },
      painTitle: '\u00bfTe suena familiar?',
      pains: {
        screenshots: {
          hook: '"Tengo miles de capturas de pantalla y no encuentro nada."',
          answer: 'El OCR lee el texto en tus im\u00e1genes. Busc\u00e1 por lo que dice la captura, no por el nombre del archivo.',
        },
        arguments: {
          hook: '"Una vez escribí la respuesta perfecta. Ahora no la encuentro."',
          answer: 'Guard\u00e1la, etiqu\u00e9tala, busc\u00e1la. La pr\u00f3xima vez que surja el tema, un clic y est\u00e1 en tu portapapeles.',
        },
        scattered: {
          hook: '"Mis ideas están en 5 apps distintas y ninguna se comunica entre sí."',
          answer: 'Un solo lugar. Texto, im\u00e1genes, links, videos. Todo etiquetado, todo buscable, todo conectado.',
        },
        connections: {
          hook: '"Sé que estas ideas están relacionadas pero no veo cómo."',
          answer: 'Descubrir muestra notas que guardaste meses atr\u00e1s con etiquetas raras en com\u00fan \u2014 conexiones que no sab\u00edas que ten\u00edas.',
        },
        video: {
          hook: '"Vi un gran video pero no recuerdo cuál decía eso."',
          answer: 'Guardá el link y tocá Resumir. Cada punto importante del video queda en la nota como texto, así que buscar el punto encuentra el video.',
        },
        prompts: {
          hook: '"Sigo reescribiendo los mismos prompts y plantillas desde cero."',
          answer: 'Guard\u00e1 tus mejores prompts, plantillas de email y respuestas enlatadas. Busc\u00e1, clic, peg\u00e1.',
        },
        draft: {
          hook: '"Mi investigaci\u00f3n est\u00e1 en una app y mi borrador en otra."',
          answer: 'Escrib\u00ed el borrador donde ya vive la investigaci\u00f3n. Cada nota, captura y fuente que guardaste est\u00e1 a una b\u00fasqueda en la misma app \u2014 no en otra pesta\u00f1a que ten\u00e9s que ir a buscar.',
        },
      },
      featuresTitle: 'Qu\u00e9 incluye',
      comingSoonBadge: 'Pr\u00f3ximamente',
      featuresSubtitle: 'Todo lo que necesit\u00e1s para capturar, organizar y reutilizar tu mejor pensamiento.',
      features: {
        brain: {
          title: 'Tu Cerebro Externo',
          description: 'Guard\u00e1 cada meme, captura, art\u00edculo y pensamiento. El OCR lee texto de im\u00e1genes para que nada se pierda.',
        },
        web: {
          title: 'Descubrir Conexiones',
          description: 'Mir\u00e1 cu\u00e1les de tus ideas est\u00e1n secretamente relacionadas. Etiquetas raras compartidas revelan conexiones sorprendentes.',
        },
        recall: {
          title: 'Memoria Instant\u00e1nea',
          description: 'Busc\u00e1 con unas letras y encontr\u00e1 lo que sea. \u00bfEsa cita? \u00bfEse link? \u00bfEsa respuesta perfecta? Ac\u00e1.',
        },
        organization: {
          title: 'Organizaci\u00f3n Inteligente',
          description: 'El etiquetado con IA mantiene todo organizado, y una imagen sin texto no es obst\u00e1culo: Yarnboard lee las palabras que hay adentro y etiqueta la captura por lo que realmente dice. Sin etiqueta no hay entrada \u2014 te mantenemos disciplinado.',
        },
        video: {
          title: 'Res\u00famenes de Video',
          description: 'Guard\u00e1 un link de YouTube y toc\u00e1 un bot\u00f3n. Cada punto importante del video queda como texto de nota que pod\u00e9s buscar, editar y reusar.',
        },
        documents: {
          title: 'Documentos Que Se Nutren de Tus Notas',
          description: 'Un editor completo que sabe d\u00f3nde est\u00e1 tu material. Tra\u00e9 las notas guardadas directo al borrador, divid\u00ed, fusion\u00e1 y reorganiz\u00e1 \u2014 la investigaci\u00f3n y la escritura en un solo lugar y no en dos.',
        },
        versions: {
          title: 'Nada Se Pierde en un Guardado',
          description: 'Tus documentos guardan sus \u00faltimas 15 versiones mientras escrib\u00eds, y se toma un punto de control apenas desaparece mucho texto. Borr\u00e1s un cap\u00edtulo sin querer y vuelve con un bot\u00f3n \u2014 tambi\u00e9n en el plan gratis.',
        },
        storyboards: {
          title: 'Storyboards Visuales',
          description: 'Organiz\u00e1 tus notas como tablero de evidencias. Arrastr\u00e1, solt\u00e1 y secuenci\u00e1 tus ideas en narrativas.',
        },
        scriptToStoryboard: {
          title: 'Gui\u00f3n a Storyboard',
          description: 'Transform\u00e1 guiones en storyboards visuales al instante. Una ventaja en la planificaci\u00f3n de producci\u00f3n.',
        },
        wordFinder: {
          title: 'Encontr\u00e1 Tus Palabras',
          description: '\u00bfPerdiste la palabra perfecta? Busc\u00e1 por contexto y significado. Llen\u00e1 los espacios con lo que quer\u00edas decir.',
        },
      },
      audienceTitle: 'Gente que lo entiende',
      audiences: {
        creators: {
          title: 'Creadores de Contenido',
          description: 'YouTubers, cineastas, documentalistas rastreando fuentes y construyendo narrativas',
        },
        journalists: {
          title: 'Periodistas',
          description: 'Reporteros investigativos manejando fuentes a trav\u00e9s de m\u00faltiples madrigueras',
        },
        writers: {
          title: 'Escritores y Autores',
          description: 'Construyendo mundos, rastreando personajes, sin perder esa l\u00ednea perfecta',
        },
        researchers: {
          title: 'Investigadores',
          description: 'Acad\u00e9micos y estudiantes manejando citas y materiales de investigaci\u00f3n',
        },
        social: {
          title: 'Profesionales de Redes',
          description: 'Influencers y estrategas que necesitan acceso instant\u00e1neo al contenido guardado',
        },
        legal: {
          title: 'Legal y Educaci\u00f3n',
          description: 'Abogados rastreando evidencia, educadores construyendo planes de estudio',
        },
        developers: {
          title: 'Desarrolladores',
          description: 'Capturando ideas, rastreando errores y dise\u00f1ando flujos de aplicaciones',
        },
        designers: {
          title: 'Dise\u00f1adores',
          description: 'Curando inspiraci\u00f3n visual como un Pinterest personal',
        },
      },
      ctaTitle: 'Tus mejores ideas merecen algo mejor que una captura olvidada.',
      ctaSubtitle: 'Gratis para empezar. Sin tarjeta de cr\u00e9dito.',
      ctaButton: 'Empezar',
    },
    about: {
      title: 'Acerca de Yarnboard',
      tagline: 'Elaborado con Pura Vida en Costa Rica \ud83c\udde8\ud83c\uddf7',
      storyTitle: 'Nuestra Historia',
      storyP1: 'Yarnboard naci\u00f3 de una frustraci\u00f3n simple: perder el rastro de pensamientos brillantes, enlaces importantes y ese meme perfecto en el momento equivocado. Cre\u00edamos que ten\u00eda que haber una mejor manera de capturar, organizar y conectar el flujo interminable de informaci\u00f3n que fluye a trav\u00e9s de nuestras vidas digitales.',
      storyP2: 'Construido con amor en las hermosas monta\u00f1as de Costa Rica, Yarnboard combina el esp\u00edritu creativo de Pura Vida con tecnolog\u00eda de vanguardia para crear tu sistema personal de gesti\u00f3n del conocimiento. Ya seas un creador de contenido rastreando fuentes, un investigador manejando citas, o simplemente alguien que se niega a perder otra gran idea\u2014Yarnboard es tu pared de conspiraci\u00f3n digital.',
      techTitle: 'Construido con Tecnolog\u00eda Moderna',
      techIntro: 'Yarnboard aprovecha la IA y el aprendizaje autom\u00e1tico de \u00faltima generaci\u00f3n para hacer que tu informaci\u00f3n trabaje para ti:',
      techFeatures: {
        ocr: 'Tecnolog\u00eda OCR: Extrae autom\u00e1ticamente texto de im\u00e1genes para que cada captura de pantalla sea buscable',
        aiTagging: 'Etiquetado con IA: Sugerencias inteligentes te ayudan a organizar sin pensar',
        videoSummaries: 'Res\u00famenes de Video: Convierte un link de YouTube en los puntos principales como texto de nota buscable',
        mindMapping: 'Mapeo Mental Visual: Descubre autom\u00e1ticamente conexiones entre tus notas',
        search: 'B\u00fasqueda de Texto Completo: Encontr\u00e1 cualquier cosa con solo unas pocas teclas',
      },
      privacyTitle: 'Pol\u00edtica de Privacidad',
      sections: {
        infoCollect: '1. Informaci\u00f3n que Recopilamos',
        howWeUse: '2. C\u00f3mo Usamos Tu Informaci\u00f3n',
        dataSecurity: '3. Almacenamiento y Seguridad de Datos',
        dataSharing: '4. Compartir y Divulgaci\u00f3n de Datos',
        yourRights: '5. Tus Derechos y Opciones',
        dataRetention: '6. Retenci\u00f3n de Datos',
        children: '7. Privacidad de Menores',
        international: '8. Transferencias Internacionales de Datos',
        changes: '9. Cambios a Esta Pol\u00edtica',
        contact: '10. Cont\u00e1ctanos',
      },
      effectiveDate: 'Fecha de Vigencia: Enero 2025',
      termsLinkText: 'Para los t\u00e9rminos legales completos, revisa nuestros',
      puraVida: '\u00a1Pura Vida!',
      privPersonalTitle: '**Información Personal:**',
      privPersonal1: 'Información de la cuenta (correo electrónico, nombre de usuario, contraseña)',
      privPersonal2: 'El contenido que creás (notas, documentos, etiquetas, enlaces)',
      privPersonal3: 'Los archivos multimedia (imágenes, videos) que subís al servicio',
      privPersonal4: 'Datos de uso (búsquedas, interacciones con funciones, marcas de tiempo)',
      privAutoTitle: '**Información Recopilada Automáticamente:**',
      privAuto1: 'Información del dispositivo (tipo de navegador, sistema operativo)',
      privAuto2: 'Dirección IP y datos generales de ubicación',
      privAuto3: 'Cookies y tecnologías de rastreo similares',
      privUse1: '**Prestación del Servicio:** Para proporcionar, mantener y mejorar las funciones de Yarnboard',
      privUse2: '**Procesamiento con IA:** Para realizar OCR, transcripción, etiquetado y búsqueda',
      privUse3: '**Gestión de la Cuenta:** Para autenticarte y administrar tu cuenta',
      privUse4: '**Comunicación:** Para enviarte actualizaciones del servicio y responder tus consultas',
      privUse5: '**Analítica:** Para entender los patrones de uso y mejorar la plataforma',
      privUse6: '**Seguridad:** Para proteger contra el fraude, el abuso y las amenazas a la seguridad',
      privSecurityBody: 'Tus datos se almacenan de forma segura en servidores ubicados en los Estados Unidos. Usamos cifrado estándar de la industria para los datos en tránsito (HTTPS/TLS) y en reposo. Implementamos medidas técnicas y organizativas apropiadas para proteger tu información contra el acceso, la divulgación, la alteración y la destrucción no autorizados.',
      privSecurityThirdParty: '**Servicios de Terceros:** Usamos proveedores confiables de infraestructura en la nube (AWS) para el almacenamiento y el procesamiento. Estos proveedores cuentan con sus propias certificaciones de seguridad y cumplen con estándares internacionales de protección de datos.',
      privSharingIntro: 'No vendemos tu información personal. Solo podemos compartir datos en estas circunstancias:',
      privSharing1: '**Con Tu Consentimiento:** Cuando nos autorizás explícitamente a compartir información',
      privSharing2: '**Proveedores de Servicios:** Con proveedores que nos ayudan a operar la plataforma (alojamiento en la nube, analítica)',
      privSharing3: '**Obligaciones Legales:** Cuando lo exija la ley, una orden judicial o una solicitud gubernamental',
      privSharing4: '**Transferencias Comerciales:** En relación con una fusión, adquisición o venta de activos',
      privSharing5: '**Protección:** Para proteger los derechos, la propiedad o la seguridad de Yarnboard, de los usuarios o del público',
      privAccessTitle: '**Acceso y Control:**',
      privAccess1: 'Acceder, descargar o eliminar tus datos en cualquier momento desde la configuración de tu cuenta',
      privAccess2: 'Modificar o corregir tu información personal',
      privAccess3: 'Exportar todo tu contenido en un formato portátil',
      privAccess4: 'Eliminar tu cuenta y todos los datos asociados',
      privCommTitle: '**Preferencias de Comunicación:**',
      privComm1: 'Darte de baja de las comunicaciones de marketing (los correos relacionados con el servicio continuarán)',
      privComm2: 'Controlar las preferencias de cookies desde la configuración de tu navegador',
      privRegionalTitle: '**Derechos Regionales:**',
      privRegional1: '**RGPD (UE):** Derecho de acceso, rectificación, supresión, portabilidad de datos y oposición',
      privRegional2: '**CCPA (California):** Derecho a saber, a eliminar y a rechazar la venta de datos',
      privRegional3: '**Otras Jurisdicciones:** Los derechos que otorguen las leyes locales aplicables',
      privRetentionBody: 'Conservamos tu información mientras tu cuenta esté activa o mientras sea necesario para prestar los servicios. Cuando eliminás contenido o tu cuenta, lo quitamos de los sistemas activos en un plazo de 30 días, aunque las copias de seguridad pueden persistir hasta 90 días con fines de recuperación ante desastres.',
      privChildrenBody: 'Yarnboard no está dirigido a usuarios menores de 13 años. No recopilamos a sabiendas información personal de menores. Si nos enteramos de que un menor nos proporcionó información personal, tomaremos medidas para eliminarla.',
      privInternationalBody: 'Si accedés a Yarnboard desde fuera de Costa Rica o de los Estados Unidos, tu información puede transferirse y procesarse en países con leyes de protección de datos diferentes. Al usar nuestro servicio, consentís esas transferencias.',
      privChangesBody: 'Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos los cambios importantes por correo electrónico o a través del servicio. El uso continuado de Yarnboard después de los cambios indica la aceptación de la política actualizada.',
      privContactIntro: 'Si tenés preguntas sobre esta Política de Privacidad o sobre nuestras prácticas de datos, contactanos:',
      privContactEmail: '**Correo:** privacy@yarnboard.com',
      privContactLocation: '**Ubicación:** Costa Rica',
    },
    terms: {
      title: 'T\u00e9rminos de Servicio',
      tagline: 'Yarnboard',
      effectiveDate: 'Fecha de Vigencia:',
      lastUpdated: '\u00daltima Actualizaci\u00f3n:',
      sections: {
        acceptance: '1. Aceptaci\u00f3n de T\u00e9rminos',
        description: '2. Descripci\u00f3n del Servicio',
        accounts: '3. Cuentas de Usuario y Seguridad',
        content: '4. Contenido del Usuario y Propiedad Intelectual',
        acceptableUse: '5. Uso Aceptable',
        payment: '6. Pagos y Suscripciones',
        privacy: '7. Privacidad y Protecci\u00f3n de Datos',
        disclaimers: '8. Descargos de Responsabilidad y Limitaciones de Responsabilidad',
        indemnification: '9. Indemnizaci\u00f3n',
        thirdParty: '10. Servicios de Terceros',
        copyright: '11. Derechos de Autor y DMCA',
        disputes: '12. Resoluci\u00f3n de Disputas y Arbitraje',
        governing: '13. Ley Aplicable y Jurisdicci\u00f3n',
        modifications: '14. Modificaciones a los T\u00e9rminos',
        severability: '15. Divisibilidad y Renuncia',
        entire: '16. Acuerdo Completo',
        contact: '17. Informaci\u00f3n de Contacto',
        euProvisions: '18. Disposiciones Especiales para Usuarios de la UE',
      },
      acknowledgment: 'AL USAR YARNBOARD, RECONOCES QUE HAS LE\u00cdDO, ENTENDIDO Y ACEPTAS ESTAR OBLIGADO POR ESTOS T\u00c9RMINOS DE SERVICIO.',
      effectiveDateValue: '1 de enero de 2025',
      lastUpdatedValue: '1 de enero de 2025',
      intro: 'Bienvenido a Yarnboard. Estos Términos de Servicio (los "Términos") rigen tu acceso y uso de los servicios, el sitio web y las aplicaciones de Yarnboard (en conjunto, el "Servicio"). Al acceder o usar el Servicio, aceptás quedar obligado por estos Términos. Si no estás de acuerdo con estos Términos, no podés usar el Servicio.',
      acceptanceIntro: 'Al crear una cuenta o usar Yarnboard, confirmás que:',
      acceptance1: 'Tenés al menos 13 años de edad (o la edad mínima exigida en tu jurisdicción)',
      acceptance2: 'Tenés la capacidad legal para celebrar un acuerdo vinculante',
      acceptance3: 'Vas a cumplir con estos Términos y con todas las leyes y regulaciones aplicables',
      acceptance4: 'Toda la información que proporcionás es precisa y está actualizada',
      descriptionIntro: 'Yarnboard es una plataforma digital de gestión del conocimiento que les permite a los usuarios:',
      description1: 'Crear, almacenar y organizar notas, documentos y contenido multimedia',
      description2: 'Subir y procesar imágenes con reconocimiento óptico de caracteres (OCR)',
      description3: 'Transcribir contenido de audio y video',
      description4: 'Crear mapas mentales visuales y conexiones entre contenidos',
      description5: 'Buscar y recuperar información almacenada',
      description6: 'Utilizar funciones con IA para la organización y el etiquetado',
      descriptionOutro: 'Nos reservamos el derecho de modificar, suspender o discontinuar cualquier aspecto del Servicio en cualquier momento, con o sin aviso, y sin responsabilidad alguna hacia vos.',
      accountsCreationTitle: '3.1 Creación de la Cuenta',
      accountsCreationIntro: 'Para usar ciertas funciones del Servicio, tenés que crear una cuenta. Aceptás:',
      accountsCreation1: 'Proporcionar información de registro precisa y completa',
      accountsCreation2: 'Mantener y actualizar sin demora la información de tu cuenta',
      accountsCreation3: 'Mantener tu contraseña segura y confidencial',
      accountsCreation4: 'Notificarnos de inmediato sobre cualquier acceso no autorizado o brecha de seguridad',
      accountsCreation5: 'Aceptar la responsabilidad por todas las actividades realizadas en tu cuenta',
      accountsTerminationTitle: '3.2 Cancelación de la Cuenta',
      accountsTerminationBody: 'Podés cancelar tu cuenta en cualquier momento desde la configuración de la cuenta. Nos reservamos el derecho de suspender o cancelar tu cuenta si violás estos Términos, realizás actividades fraudulentas o por cualquier otra razón, a nuestra entera discreción.',
      contentYoursTitle: '4.1 Tu Contenido',
      contentYoursIntro: 'Conservás todos los derechos de propiedad sobre el contenido que creás, subís o almacenás en Yarnboard (el "Contenido del Usuario"). Al usar el Servicio, le otorgás a Yarnboard una licencia mundial, no exclusiva y libre de regalías para:',
      contentYours1: 'Almacenar, procesar y transmitir tu Contenido del Usuario para prestar el Servicio',
      contentYours2: 'Realizar OCR, transcripción y análisis con IA sobre tu Contenido del Usuario',
      contentYours3: 'Crear copias de seguridad y formatos derivados necesarios para el funcionamiento del Servicio',
      contentYoursOutro: 'Esta licencia termina cuando eliminás tu contenido o tu cuenta, salvo por el contenido compartido con otros usuarios o cuando la ley lo exija.',
      contentResponsibilityTitle: '4.2 Responsabilidad por el Contenido',
      contentResponsibilityIntro: 'Sos el único responsable de tu Contenido del Usuario. Declarás y garantizás que:',
      contentResponsibility1: 'Sos el titular o contás con los derechos necesarios sobre todo el Contenido del Usuario que subís',
      contentResponsibility2: 'Tu Contenido del Usuario no viola derechos de terceros (derechos de autor, marcas, privacidad, etc.)',
      contentResponsibility3: 'Tu Contenido del Usuario cumple con estos Términos y con las leyes aplicables',
      contentProhibitedTitle: '4.3 Contenido Prohibido',
      contentProhibitedIntro: 'No podés subir, almacenar ni compartir contenido que:',
      contentProhibited1: 'Sea ilegal, dañino, amenazante, abusivo, acosador, difamatorio o de odio',
      contentProhibited2: 'Infrinja derechos de propiedad intelectual u otros derechos de propiedad',
      contentProhibited3: 'Contenga malware, virus u otro código dañino',
      contentProhibited4: 'Viole derechos de privacidad o contenga información personal no autorizada',
      contentProhibited5: 'Promueva actividades ilegales o violencia',
      contentProhibited6: 'Contenga material de abuso sexual infantil o explote a menores',
      contentProhibited7: 'Constituya spam o contenido comercial no solicitado',
      contentOurRightsTitle: '4.4 Nuestros Derechos',
      contentOurRightsBody: 'Yarnboard y sus licenciantes conservan todos los derechos, títulos e intereses sobre el Servicio, incluidos todo el software, la tecnología, los diseños y las marcas. Estos Términos no te otorgan ningún derecho para usar la propiedad intelectual de Yarnboard, salvo lo necesario para usar el Servicio.',
      acceptableUseIntro: 'Aceptás no:',
      acceptableUse1: 'Usar el Servicio con fines ilegales o en violación de cualquier ley',
      acceptableUse2: 'Intentar obtener acceso no autorizado al Servicio o a las cuentas de otros usuarios',
      acceptableUse3: 'Interferir con el Servicio o los servidores, o interrumpirlos',
      acceptableUse4: 'Usar sistemas automatizados (bots, scrapers) sin permiso',
      acceptableUse5: 'Aplicar ingeniería inversa, descompilar o desensamblar cualquier parte del Servicio',
      acceptableUse6: 'Eliminar o modificar avisos de derechos de autor, de marcas o de propiedad',
      acceptableUse7: 'Suplantar a cualquier persona o entidad o tergiversar tu afiliación',
      acceptableUse8: 'Recopilar o extraer información sobre otros usuarios',
      acceptableUse9: 'Usar el Servicio para enviar spam o mensajes no solicitados',
      acceptableUse10: 'Sobrecargar o intentar saturar nuestra infraestructura',
      paymentPricingTitle: '6.1 Precios',
      paymentPricingBody: 'Ciertas funciones o niveles del Servicio pueden requerir pago. Todas las tarifas están expresadas en dólares estadounidenses, salvo que se indique lo contrario. Nos reservamos el derecho de cambiar nuestros precios con 30 días de aviso.',
      paymentBillingTitle: '6.2 Facturación',
      paymentBillingIntro: 'Si comprás una suscripción:',
      paymentBilling1: 'Nos autorizás a cobrar tu medio de pago de forma recurrente',
      paymentBilling2: 'Las suscripciones se renuevan automáticamente a menos que se cancelen antes de la fecha de renovación',
      paymentBilling3: 'Sos responsable de todos los cargos generados en tu cuenta',
      paymentBilling4: 'Los reembolsos se otorgan solo cuando la ley lo exige o a nuestra discreción',
      paymentCancellationTitle: '6.3 Cancelación',
      paymentCancellationBody: 'Podés cancelar tu suscripción en cualquier momento desde la configuración de la cuenta. La cancelación entra en vigencia al final del período de facturación actual. No se otorgan reembolsos parciales por el tiempo no utilizado.',
      privacyBody: 'Tu uso del Servicio está sujeto a nuestra Política de Privacidad, que explica cómo recopilamos, usamos y protegemos tu información personal. Al usar el Servicio, consentís nuestras prácticas de datos según se describen en la Política de Privacidad.',
      privacyGdpr: '**Cumplimiento del RGPD:** Para los usuarios de la Unión Europea, cumplimos con el Reglamento General de Protección de Datos (RGPD). Tenés derechos de acceso, rectificación, supresión, portabilidad de datos y oposición respecto de tus datos personales.',
      disclaimersAsIsTitle: '8.1 El Servicio "Tal Cual"',
      disclaimersAsIsBody: 'EL SERVICIO SE PROPORCIONA "TAL CUAL" Y "SEGÚN DISPONIBILIDAD", SIN GARANTÍAS DE NINGÚN TIPO, EXPRESAS O IMPLÍCITAS, INCLUIDAS, ENTRE OTRAS, LAS GARANTÍAS DE COMERCIABILIDAD, IDONEIDAD PARA UN FIN DETERMINADO, NO INFRACCIÓN O EXACTITUD.',
      disclaimersNoWarrantyIntro: 'No garantizamos que:',
      disclaimersNoWarranty1: 'El Servicio será ininterrumpido, seguro o libre de errores',
      disclaimersNoWarranty2: 'El contenido será preciso, completo o confiable',
      disclaimersNoWarranty3: 'Los defectos serán corregidos',
      disclaimersNoWarranty4: 'El Servicio está libre de virus o componentes dañinos',
      disclaimersLiabilityTitle: '8.2 Limitación de Responsabilidad',
      disclaimersLiabilityP1: 'EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, YARNBOARD NO SERÁ RESPONSABLE POR NINGÚN DAÑO INDIRECTO, INCIDENTAL, ESPECIAL, CONSECUENTE O PUNITIVO, INCLUIDOS, ENTRE OTROS, LA PÉRDIDA DE DATOS, LA PÉRDIDA DE GANANCIAS O LA INTERRUPCIÓN DEL NEGOCIO, QUE SURJA DE TU USO O DE TU IMPOSIBILIDAD DE USAR EL SERVICIO O QUE SE RELACIONE CON ELLOS.',
      disclaimersLiabilityP2: 'EN LAS JURISDICCIONES QUE NO PERMITEN LA LIMITACIÓN DE RESPONSABILIDAD, NUESTRA RESPONSABILIDAD SE LIMITA A LA MÁXIMA MEDIDA PERMITIDA POR LA LEY. EN NINGÚN CASO NUESTRA RESPONSABILIDAD TOTAL EXCEDERÁ EL MONTO QUE NOS PAGASTE EN LOS 12 MESES ANTERIORES AL RECLAMO, O $100, LO QUE SEA MAYOR.',
      disclaimersBackupTitle: '8.3 Responsabilidad de Respaldo',
      disclaimersBackupBody: 'Aunque implementamos sistemas de respaldo, sos responsable de mantener tus propias copias de seguridad del contenido importante. No somos responsables por la pérdida o corrupción de tus datos.',
      indemnificationIntro: 'Aceptás indemnizar, defender y eximir de responsabilidad a Yarnboard, a sus directivos, directores, empleados y agentes frente a cualquier reclamo, responsabilidad, daño, pérdida, costo o gasto (incluidos los honorarios razonables de abogados) que surja de:',
      indemnification1: 'Tu uso o uso indebido del Servicio',
      indemnification2: 'Tu incumplimiento de estos Términos',
      indemnification3: 'Tu violación de derechos de terceros',
      indemnification4: 'Tu Contenido del Usuario',
      thirdPartyBody: 'El Servicio puede integrarse con servicios, sitios web o contenidos de terceros, o enlazar a ellos. No controlamos los servicios de terceros ni somos responsables de ellos. Usás los servicios de terceros bajo tu propio riesgo y sujeto a sus términos y políticas.',
      copyrightIntro: 'Respetamos los derechos de propiedad intelectual. Si creés que algún contenido en Yarnboard infringe tus derechos de autor, contactanos con:',
      copyright1: 'La identificación de la obra protegida por derechos de autor',
      copyright2: 'La identificación del material infractor y su ubicación',
      copyright3: 'Tu información de contacto',
      copyright4: 'Una declaración de buena fe de que el uso no está autorizado',
      copyright5: 'Una declaración de que la información es precisa y de que estás autorizado para actuar',
      copyright6: 'Tu firma física o electrónica',
      copyrightOutro: 'Responderemos a las notificaciones válidas presentadas bajo la DMCA y podemos cancelar las cuentas de infractores reincidentes.',
      disputesInformalTitle: '12.1 Resolución Informal',
      disputesInformalBody: 'Antes de iniciar un procedimiento formal, aceptás contactarnos para intentar resolver cualquier disputa de manera informal.',
      disputesArbitrationTitle: '12.2 Arbitraje (Usuarios de EE. UU.)',
      disputesArbitrationBody: 'Para los usuarios en los Estados Unidos, cualquier disputa que surja de estos Términos o del Servicio se resolverá mediante arbitraje vinculante conforme a las reglas de la American Arbitration Association, salvo donde la ley lo prohíba.',
      disputesEuTitle: '12.3 Usuarios de la UE',
      disputesEuBody: 'Para los usuarios de la Unión Europea, las disputas pueden presentarse ante los tribunales competentes de tu país de residencia. Los consumidores de la UE también pueden usar la plataforma de Resolución de Litigios en Línea de la Comisión Europea en: https://ec.europa.eu/consumers/odr',
      disputesClassActionTitle: '12.4 Renuncia a Acciones Colectivas',
      disputesClassActionBody: 'En la medida en que la ley lo permita, aceptás que las disputas se resolverán de forma individual y renunciás al derecho de participar en acciones colectivas o en arbitrajes colectivos.',
      governingBody: 'Estos Términos se rigen por las leyes de Costa Rica, sin tener en cuenta los principios sobre conflicto de leyes. Para los usuarios de la UE, se aplicarán, cuando corresponda, las leyes imperativas de protección al consumidor de tu país de residencia.',
      modificationsP1: 'Podemos modificar estos Términos en cualquier momento publicando los Términos actualizados en nuestro sitio web. Los cambios importantes se notificarán por correo electrónico o a través del Servicio al menos 30 días antes de entrar en vigencia. El uso continuado después de los cambios constituye la aceptación de los Términos modificados.',
      modificationsP2: 'Si no estás de acuerdo con los Términos modificados, tenés que dejar de usar el Servicio y podés cancelar tu cuenta.',
      severabilityBody: 'Si alguna disposición de estos Términos se considera inválida o inaplicable, las demás disposiciones seguirán en pleno vigor. El hecho de que no hagamos valer algún derecho o disposición no constituye una renuncia a ese derecho o disposición.',
      entireBody: 'Estos Términos, junto con nuestra Política de Privacidad, constituyen el acuerdo completo entre vos y Yarnboard respecto del Servicio y reemplazan todos los acuerdos y entendimientos previos.',
      contactIntro: 'Si tenés preguntas sobre estos Términos o sobre el Servicio, contactanos:',
      contactEmail: '**Correo:** legal@yarnboard.com',
      contactSupport: '**Soporte:** support@yarnboard.com',
      contactLocation: '**Ubicación:** Costa Rica',
      euIntro: 'Además de los términos anteriores, las siguientes disposiciones se aplican a los usuarios de la Unión Europea:',
      euWithdrawal: '**Derecho de Desistimiento:** Tenés 14 días para desistir de una compra sin dar ningún motivo',
      euGuarantees: '**Garantías del Consumidor:** El contenido digital debe corresponder a lo descrito y ser apto para su propósito',
      euUnfair: '**Cláusulas Abusivas:** Las cláusulas contractuales abusivas no son vinculantes para los consumidores de la UE',
      euDataProtection: '**Protección de Datos:** Estos Términos no pueden hacer que renuncies a tus derechos bajo el RGPD',
    },
    auth: {
      loginTitle: 'Iniciar Sesi\u00f3n',
      emailLabel: 'Correo:',
      passwordLabel: 'Contrase\u00f1a:',
      loggingIn: 'Iniciando sesi\u00f3n...',
      loginButton: 'Iniciar Sesi\u00f3n',
      invalidCredentials: 'Usuario o contrase\u00f1a incorrectos',
      noAccount: '\u00bfNo ten\u00e9s cuenta? ',
      registerHere: 'Registrate ac\u00e1',
      registerTitle: 'Registrarse',
      emailField: 'Correo Electr\u00f3nico',
      passwordField: 'Contrase\u00f1a',
      confirmPasswordField: 'Confirmar Contrase\u00f1a',
      usernameOptional: 'Usuario (opcional)',
      registering: 'Registrando...',
      registerButton: 'Registrarse',
      haveAccount: '\u00bfYa ten\u00e9s cuenta? ',
      loginHere: 'Inici\u00e1 sesi\u00f3n ac\u00e1',
      invalidEmail: 'Ingres\u00e1 un correo electr\u00f3nico v\u00e1lido',
      passwordsDoNotMatch: 'Las contrase\u00f1as no coinciden',
      passwordTooShort: 'La contrase\u00f1a debe tener al menos 8 caracteres',
      emailErrorPrefix: 'Correo: {message}',
      passwordErrorPrefix: 'Contrase\u00f1a: {message}',
      registrationFailed: 'No se pudo completar el registro. Intent\u00e1 de nuevo.',
      orDivider: 'o',
      googleLoadFailed: 'No se pudo cargar el inicio de sesi\u00f3n con Google',
      googleSignInFailed: 'Fall\u00f3 el inicio de sesi\u00f3n con Google',
      handoffMissingCode: 'A este enlace de inicio de sesi\u00f3n le falta el c\u00f3digo.',
      handoffInvalid: 'Este enlace de inicio de sesi\u00f3n no es v\u00e1lido o ya venci\u00f3. Intent\u00e1 de nuevo desde la app.',
      handoffFailedTitle: 'No pudimos iniciar tu sesi\u00f3n',
      handoffLogIn: 'Iniciar sesi\u00f3n',
      handoffSigningIn: 'Iniciando tu sesi\u00f3n\u2026',
    },
  },
  pt: {
    nav: {
      home: 'In\u00edcio',
      about: 'Sobre',
      login: 'Entrar',
    },
    footer: {
      madeWith: 'Feito com \u2764\ufe0f na Costa Rica \ud83c\udde8\ud83c\uddf7',
      privacyPolicy: 'Pol\u00edtica de Privacidade',
      terms: 'Termos de Servi\u00e7o',
    },
    landing: {
      title: 'Yarnboard',
      tagline: 'Nunca mais perca uma boa ideia.',
      subtitle: 'Guarde pensamentos, prints, argumentos e memes em uma mem\u00f3ria pesquis\u00e1vel que d\u00e1 para reaproveitar de verdade.',
      getStarted: 'Come\u00e7ar Gr\u00e1tis',
      learnMore: 'Ver Como Funciona',
      appStore: 'Baixar na App Store',
      workflowTitle: 'Como funciona',
      workflowSubtitle: 'Cinco passos. S\u00f3 isso.',
      workflow: {
        save: {
          step: '1',
          title: 'Salve qualquer coisa',
          description: 'Um print, uma cita\u00e7\u00e3o, um meme, aquele argumento que levou 20 minutos para escrever. \u00c9 s\u00f3 colar.',
        },
        tag: {
          step: '2',
          title: 'Etiquete',
          description: 'Adicione algumas etiquetas. A IA sugere para voc\u00ea. Sem etiqueta, sem entrada \u2014 assim nada se perde no vazio.',
        },
        find: {
          step: '3',
          title: 'Ache na hora',
          description: 'Busque por algumas letras. Por etiqueta. Pelo texto que aparecia no print. Tudo \u00e9 pesquis\u00e1vel.',
        },
        connect: {
          step: '4',
          title: 'Veja as conex\u00f5es',
          description: 'Etiquetas em comum costuram suas notas umas nas outras. O Descobrir puxa o fio entre ideias que voc\u00ea nunca pensou em ligar \u2014 \u00e9 esse o quadro que d\u00e1 nome ao app.',
        },
        reuse: {
          step: '5',
          title: 'Reaproveite',
          description: 'Clique para copiar. Cole em uma conversa, num doc, num post. A resposta perfeita, pronta quando voc\u00ea precisar.',
        },
      },
      painTitle: 'Soa familiar?',
      pains: {
        screenshots: {
          hook: '"Tenho milhares de prints e n\u00e3o acho nada."',
          answer: 'O OCR l\u00ea o texto das suas imagens. Busque pelo que o print diz, n\u00e3o pelo nome que voc\u00ea deu ao arquivo.',
        },
        arguments: {
          hook: '"Uma vez escrevi a resposta perfeita. Agora n\u00e3o acho mais."',
          answer: 'Salve, etiquete, busque. Da pr\u00f3xima vez que o assunto voltar, um clique e est\u00e1 na sua \u00e1rea de transfer\u00eancia.',
        },
        scattered: {
          hook: '"Minhas ideias est\u00e3o em 5 apps diferentes e nenhum conversa com o outro."',
          answer: 'Um lugar s\u00f3. Texto, imagens, links, v\u00eddeos. Tudo etiquetado, tudo pesquis\u00e1vel, tudo conectado.',
        },
        connections: {
          hook: '"Sei que essas ideias t\u00eam a ver, mas n\u00e3o consigo ver como."',
          answer: 'O Descobrir traz \u00e0 tona notas que voc\u00ea salvou com meses de diferen\u00e7a e que dividem etiquetas raras \u2014 conex\u00f5es que voc\u00ea nem sabia que tinha.',
        },
        video: {
          hook: '"Assisti a um v\u00eddeo \u00f3timo mas n\u00e3o lembro qual deles falou aquilo."',
          answer: 'Salve o link e aperte Resumir. Cada ponto importante do v\u00eddeo vira texto na nota, ent\u00e3o buscar pelo ponto acha o v\u00eddeo.',
        },
        prompts: {
          hook: '"Vivo reescrevendo os mesmos prompts e modelos do zero."',
          answer: 'Salve seus melhores prompts, modelos de e-mail e respostas prontas. Busque, clique, cole.',
        },
        draft: {
          hook: '"Minha pesquisa est\u00e1 em um app e meu rascunho em outro."',
          answer: 'Escreva o rascunho onde a pesquisa j\u00e1 mora. Cada nota, captura e fonte que voc\u00ea salvou est\u00e1 a uma busca de dist\u00e2ncia no mesmo app \u2014 e n\u00e3o em outra aba que voc\u00ea precisa ir procurar.',
        },
      },
      featuresTitle: 'O que tem dentro',
      comingSoonBadge: 'Em breve',
      featuresSubtitle: 'Tudo o que voc\u00ea precisa para capturar, organizar e reaproveitar suas melhores ideias.',
      features: {
        brain: {
          title: 'Seu C\u00e9rebro Externo',
          description: 'Guarde cada meme, print, artigo e pensamento. O OCR l\u00ea o texto das imagens, ent\u00e3o nada se perde.',
        },
        web: {
          title: 'Descubra Conex\u00f5es',
          description: 'Veja quais das suas ideias s\u00e3o secretamente parentes. Etiquetas raras em comum revelam conex\u00f5es surpreendentes.',
        },
        recall: {
          title: 'Mem\u00f3ria Instant\u00e2nea',
          description: 'Busque com algumas letras e ache qualquer coisa. Aquela cita\u00e7\u00e3o? Aquele link? Aquela resposta perfeita? Est\u00e1 aqui.',
        },
        organization: {
          title: 'Organiza\u00e7\u00e3o Inteligente',
          description: 'O etiquetamento com IA mant\u00e9m tudo em ordem, e uma imagem sem legenda n\u00e3o \u00e9 problema: o Yarnboard l\u00ea as palavras dentro dela e etiqueta o print pelo que ele realmente diz. Sem etiqueta, sem entrada \u2014 a gente mant\u00e9m voc\u00ea na linha.',
        },
        video: {
          title: 'Resumos de V\u00eddeo',
          description: 'Salve um link do YouTube e aperte um bot\u00e3o. Cada ponto importante do v\u00eddeo vira texto de nota que voc\u00ea pode buscar, editar e reaproveitar.',
        },
        documents: {
          title: 'Documentos Alimentados Pelas Suas Notas',
          description: 'Um editor completo que sabe onde est\u00e1 o seu material. Puxe as notas salvas direto para o rascunho, divida, mescle e reorganize \u2014 a pesquisa e a escrita no mesmo lugar, n\u00e3o em dois.',
        },
        versions: {
          title: 'Nada Se Perde num Salvamento',
          description: 'Seus documentos guardam as \u00faltimas 15 vers\u00f5es enquanto voc\u00ea escreve, e um ponto de controle \u00e9 criado assim que muito texto desaparece. Apagou um cap\u00edtulo sem querer e ele volta com um bot\u00e3o \u2014 no plano gr\u00e1tis tamb\u00e9m.',
        },
        storyboards: {
          title: 'Storyboards Visuais',
          description: 'Organize suas notas como o quadro de evid\u00eancias de um detetive. Arraste, solte e sequencie suas ideias em narrativas.',
        },
        scriptToStoryboard: {
          title: 'Roteiro para Storyboard',
          description: 'Transforme roteiros em storyboards visuais na hora. Um empurr\u00e3o inicial no planejamento de produ\u00e7\u00e3o.',
        },
        wordFinder: {
          title: 'Ache Suas Palavras',
          description: 'Perdeu a palavra perfeita? Busque por contexto e significado. Preencha as lacunas com exatamente o que voc\u00ea queria dizer.',
        },
      },
      audienceTitle: 'Gente que entende',
      audiences: {
        creators: {
          title: 'Criadores de Conte\u00fado',
          description: 'YouTubers, cineastas e documentaristas rastreando fontes e construindo narrativas',
        },
        journalists: {
          title: 'Jornalistas',
          description: 'Rep\u00f3rteres investigativos gerenciando fontes em v\u00e1rias tocas de coelho ao mesmo tempo',
        },
        writers: {
          title: 'Escritores e Autores',
          description: 'Construindo mundos, acompanhando personagens, nunca perdendo aquela frase perfeita',
        },
        researchers: {
          title: 'Pesquisadores',
          description: 'Acad\u00eamicos e estudantes gerenciando cita\u00e7\u00f5es e material de pesquisa',
        },
        social: {
          title: 'Profissionais de Redes Sociais',
          description: 'Influenciadores e estrategistas que precisam de acesso imediato ao conte\u00fado salvo',
        },
        legal: {
          title: 'Direito e Educa\u00e7\u00e3o',
          description: 'Advogados acompanhando provas, educadores montando curr\u00edculos',
        },
        developers: {
          title: 'Desenvolvedores de Software',
          description: 'Capturando ideias de funcionalidades, rastreando bugs e desenhando fluxos de aplica\u00e7\u00e3o',
        },
        designers: {
          title: 'Designers',
          description: 'Curando inspira\u00e7\u00e3o visual como um Pinterest pessoal',
        },
      },
      ctaTitle: 'Suas melhores ideias merecem mais do que um print esquecido.',
      ctaSubtitle: 'Gr\u00e1tis para come\u00e7ar. Sem cart\u00e3o de cr\u00e9dito.',
      ctaButton: 'Come\u00e7ar',
    },
    about: {
      title: 'Sobre o Yarnboard',
      tagline: 'Feito com Pura Vida na Costa Rica \ud83c\udde8\ud83c\uddf7',
      storyTitle: 'Nossa Hist\u00f3ria',
      storyP1: 'O Yarnboard nasceu de uma frustra\u00e7\u00e3o simples: perder de vista pensamentos brilhantes, links importantes e aquele meme perfeito bem na hora errada. A gente acreditava que tinha de existir um jeito melhor de capturar, organizar e conectar o fluxo intermin\u00e1vel de informa\u00e7\u00e3o que passa pela nossa vida digital.',
      storyP2: 'Constru\u00eddo com carinho nas montanhas da Costa Rica, o Yarnboard une o esp\u00edrito criativo do Pura Vida a tecnologia de ponta para criar o seu sistema pessoal de gest\u00e3o de conhecimento. Se voc\u00ea \u00e9 criador de conte\u00fado rastreando fontes, pesquisador gerenciando cita\u00e7\u00f5es ou s\u00f3 algu\u00e9m que se recusa a perder mais uma boa ideia \u2014 o Yarnboard \u00e9 o seu mural de conspira\u00e7\u00e3o digital.',
      techTitle: 'Constru\u00eddo sobre Tecnologia Moderna',
      techIntro: 'O Yarnboard usa IA e aprendizado de m\u00e1quina de ponta para fazer sua informa\u00e7\u00e3o trabalhar por voc\u00ea:',
      techFeatures: {
        ocr: 'Tecnologia de OCR: extrai texto de imagens automaticamente, ent\u00e3o todo print \u00e9 pesquis\u00e1vel',
        aiTagging: 'Etiquetamento com IA: sugest\u00f5es inteligentes ajudam voc\u00ea a organizar sem pensar',
        videoSummaries: 'Resumos de V\u00eddeo: transforma um link do YouTube nos pontos principais do v\u00eddeo como texto pesquis\u00e1vel',
        mindMapping: 'Mapa Mental Visual: descobre automaticamente conex\u00f5es entre suas notas',
        search: 'Busca em Texto Completo: ache qualquer coisa com algumas teclas',
      },
      privacyTitle: 'Pol\u00edtica de Privacidade',
      sections: {
        infoCollect: '1. Informa\u00e7\u00f5es Que Coletamos',
        howWeUse: '2. Como Usamos Suas Informa\u00e7\u00f5es',
        dataSecurity: '3. Armazenamento e Seguran\u00e7a dos Dados',
        dataSharing: '4. Compartilhamento e Divulga\u00e7\u00e3o de Dados',
        yourRights: '5. Seus Direitos e Escolhas',
        dataRetention: '6. Reten\u00e7\u00e3o de Dados',
        children: '7. Privacidade de Crian\u00e7as',
        international: '8. Transfer\u00eancias Internacionais de Dados',
        changes: '9. Altera\u00e7\u00f5es Nesta Pol\u00edtica',
        contact: '10. Fale Conosco',
      },
      effectiveDate: 'Data de Vig\u00eancia: Janeiro de 2025',
      termsLinkText: 'Para os termos legais completos, consulte nossos',
      puraVida: 'Pura Vida!',
      privPersonalTitle: '**Informações Pessoais:**',
      privPersonal1: 'Informações da conta (endereço de e-mail, nome de usuário, senha)',
      privPersonal2: 'O conteúdo que você cria (notas, documentos, etiquetas, links)',
      privPersonal3: 'Os arquivos de mídia (imagens, vídeos) que você envia ao serviço',
      privPersonal4: 'Dados de uso (buscas, interações com recursos, registros de data e hora)',
      privAutoTitle: '**Informações Coletadas Automaticamente:**',
      privAuto1: 'Informações do dispositivo (tipo de navegador, sistema operacional)',
      privAuto2: 'Endereço IP e dados gerais de localização',
      privAuto3: 'Cookies e tecnologias de rastreamento semelhantes',
      privUse1: '**Entrega do Serviço:** Para fornecer, manter e melhorar os recursos do Yarnboard',
      privUse2: '**Processamento com IA:** Para realizar OCR, transcrição, etiquetamento e busca',
      privUse3: '**Gestão da Conta:** Para autenticar você e administrar sua conta',
      privUse4: '**Comunicação:** Para enviar atualizações do serviço e responder às suas dúvidas',
      privUse5: '**Análise:** Para entender padrões de uso e melhorar a plataforma',
      privUse6: '**Segurança:** Para proteger contra fraude, abuso e ameaças à segurança',
      privSecurityBody: 'Seus dados são armazenados com segurança em servidores localizados nos Estados Unidos. Usamos criptografia padrão do setor para dados em trânsito (HTTPS/TLS) e em repouso. Implementamos medidas técnicas e organizacionais adequadas para proteger suas informações contra acesso, divulgação, alteração e destruição não autorizados.',
      privSecurityThirdParty: '**Serviços de Terceiros:** Usamos provedores confiáveis de infraestrutura em nuvem (AWS) para armazenamento e processamento. Esses provedores têm suas próprias certificações de segurança e cumprem padrões internacionais de proteção de dados.',
      privSharingIntro: 'Não vendemos suas informações pessoais. Só podemos compartilhar dados nestas circunstâncias:',
      privSharing1: '**Com Seu Consentimento:** Quando você nos autoriza expressamente a compartilhar informações',
      privSharing2: '**Prestadores de Serviços:** Com fornecedores que nos ajudam a operar a plataforma (hospedagem em nuvem, análise)',
      privSharing3: '**Obrigações Legais:** Quando exigido por lei, ordem judicial ou solicitação governamental',
      privSharing4: '**Transferências Empresariais:** Em conexão com fusão, aquisição ou venda de ativos',
      privSharing5: '**Proteção:** Para proteger direitos, propriedade ou segurança do Yarnboard, dos usuários ou do público',
      privAccessTitle: '**Acesso e Controle:**',
      privAccess1: 'Acessar, baixar ou excluir seus dados a qualquer momento nas configurações da sua conta',
      privAccess2: 'Modificar ou corrigir suas informações pessoais',
      privAccess3: 'Exportar todo o seu conteúdo em um formato portátil',
      privAccess4: 'Excluir sua conta e todos os dados associados',
      privCommTitle: '**Preferências de Comunicação:**',
      privComm1: 'Cancelar o recebimento de comunicações de marketing (os e-mails relacionados ao serviço continuarão)',
      privComm2: 'Controlar as preferências de cookies nas configurações do seu navegador',
      privRegionalTitle: '**Direitos Regionais:**',
      privRegional1: '**GDPR (UE):** Direito de acesso, retificação, exclusão, portabilidade de dados e oposição',
      privRegional2: '**CCPA (Califórnia):** Direito de saber, de excluir e de recusar a venda de dados',
      privRegional3: '**Outras Jurisdições:** Os direitos previstos nas leis locais aplicáveis',
      privRetentionBody: 'Mantemos suas informações enquanto sua conta estiver ativa ou pelo tempo necessário para prestar os serviços. Quando você exclui conteúdo ou sua conta, nós o removemos dos sistemas ativos em até 30 dias, embora cópias de backup possam permanecer por até 90 dias para fins de recuperação de desastres.',
      privChildrenBody: 'O Yarnboard não se destina a usuários com menos de 13 anos. Não coletamos intencionalmente informações pessoais de crianças. Se soubermos que uma criança nos forneceu informações pessoais, tomaremos medidas para excluí-las.',
      privInternationalBody: 'Se você acessar o Yarnboard de fora da Costa Rica ou dos Estados Unidos, suas informações podem ser transferidas e processadas em países com leis de proteção de dados diferentes. Ao usar nosso serviço, você consente com essas transferências.',
      privChangesBody: 'Podemos atualizar esta Política de Privacidade de tempos em tempos. Avisaremos você sobre alterações significativas por e-mail ou pelo serviço. O uso continuado do Yarnboard após as alterações indica aceitação da política atualizada.',
      privContactIntro: 'Para dúvidas sobre esta Política de Privacidade ou sobre nossas práticas de dados, entre em contato conosco:',
      privContactEmail: '**E-mail:** privacy@yarnboard.com',
      privContactLocation: '**Localização:** Costa Rica',
    },
    terms: {
      title: 'Termos de Servi\u00e7o',
      tagline: 'Yarnboard',
      effectiveDate: 'Data de Vig\u00eancia:',
      lastUpdated: '\u00daltima Atualiza\u00e7\u00e3o:',
      sections: {
        acceptance: '1. Aceita\u00e7\u00e3o dos Termos',
        description: '2. Descri\u00e7\u00e3o do Servi\u00e7o',
        accounts: '3. Contas de Usu\u00e1rio e Seguran\u00e7a',
        content: '4. Conte\u00fado do Usu\u00e1rio e Propriedade Intelectual',
        acceptableUse: '5. Uso Aceit\u00e1vel',
        payment: '6. Pagamentos e Assinaturas',
        privacy: '7. Privacidade e Prote\u00e7\u00e3o de Dados',
        disclaimers: '8. Isen\u00e7\u00f5es e Limita\u00e7\u00f5es de Responsabilidade',
        indemnification: '9. Indeniza\u00e7\u00e3o',
        thirdParty: '10. Servi\u00e7os de Terceiros',
        copyright: '11. Direitos Autorais e DMCA',
        disputes: '12. Resolu\u00e7\u00e3o de Disputas e Arbitragem',
        governing: '13. Lei Aplic\u00e1vel e Jurisdi\u00e7\u00e3o',
        modifications: '14. Modifica\u00e7\u00f5es dos Termos',
        severability: '15. Autonomia das Cl\u00e1usulas e Ren\u00fancia',
        entire: '16. Acordo Integral',
        contact: '17. Informa\u00e7\u00f5es de Contato',
        euProvisions: '18. Disposi\u00e7\u00f5es Especiais para Usu\u00e1rios da UE',
      },
      acknowledgment: 'AO USAR O YARNBOARD, VOC\u00ca RECONHECE QUE LEU, ENTENDEU E CONCORDA EM SE VINCULAR A ESTES TERMOS DE SERVI\u00c7O.',
      effectiveDateValue: '1º de janeiro de 2025',
      lastUpdatedValue: '1º de janeiro de 2025',
      intro: 'Bem-vindo ao Yarnboard. Estes Termos de Serviço (os "Termos") regem seu acesso e uso dos serviços, do site e dos aplicativos do Yarnboard (em conjunto, o "Serviço"). Ao acessar ou usar o Serviço, você concorda em se vincular a estes Termos. Se você não concorda com estes Termos, não pode usar o Serviço.',
      acceptanceIntro: 'Ao criar uma conta ou usar o Yarnboard, você confirma que:',
      acceptance1: 'Você tem pelo menos 13 anos de idade (ou a idade mínima exigida na sua jurisdição)',
      acceptance2: 'Você tem capacidade legal para celebrar um acordo vinculante',
      acceptance3: 'Você cumprirá estes Termos e todas as leis e regulamentos aplicáveis',
      acceptance4: 'Todas as informações que você fornece são precisas e estão atualizadas',
      descriptionIntro: 'O Yarnboard é uma plataforma digital de gestão de conhecimento que permite aos usuários:',
      description1: 'Criar, armazenar e organizar notas, documentos e conteúdo de mídia',
      description2: 'Enviar e processar imagens com reconhecimento óptico de caracteres (OCR)',
      description3: 'Transcrever conteúdo de áudio e vídeo',
      description4: 'Criar mapas mentais visuais e conexões entre conteúdos',
      description5: 'Buscar e recuperar informações armazenadas',
      description6: 'Utilizar recursos com IA para organização e etiquetamento',
      descriptionOutro: 'Reservamo-nos o direito de modificar, suspender ou descontinuar qualquer aspecto do Serviço a qualquer momento, com ou sem aviso, e sem responsabilidade perante você.',
      accountsCreationTitle: '3.1 Criação da Conta',
      accountsCreationIntro: 'Para usar certos recursos do Serviço, você precisa criar uma conta. Você concorda em:',
      accountsCreation1: 'Fornecer informações de cadastro precisas e completas',
      accountsCreation2: 'Manter e atualizar prontamente as informações da sua conta',
      accountsCreation3: 'Manter sua senha segura e confidencial',
      accountsCreation4: 'Notificar-nos imediatamente sobre qualquer acesso não autorizado ou violação de segurança',
      accountsCreation5: 'Aceitar a responsabilidade por todas as atividades realizadas na sua conta',
      accountsTerminationTitle: '3.2 Encerramento da Conta',
      accountsTerminationBody: 'Você pode encerrar sua conta a qualquer momento nas configurações da conta. Reservamo-nos o direito de suspender ou encerrar sua conta caso você viole estes Termos, pratique atividade fraudulenta ou por qualquer outro motivo, a nosso exclusivo critério.',
      contentYoursTitle: '4.1 Seu Conteúdo',
      contentYoursIntro: 'Você mantém todos os direitos de propriedade sobre o conteúdo que cria, envia ou armazena no Yarnboard (o "Conteúdo do Usuário"). Ao usar o Serviço, você concede ao Yarnboard uma licença mundial, não exclusiva e isenta de royalties para:',
      contentYours1: 'Armazenar, processar e transmitir seu Conteúdo do Usuário para fornecer o Serviço',
      contentYours2: 'Realizar OCR, transcrição e análise com IA sobre seu Conteúdo do Usuário',
      contentYours3: 'Criar backups e formatos derivados necessários para a operação do Serviço',
      contentYoursOutro: 'Esta licença termina quando você exclui seu conteúdo ou sua conta, exceto quanto ao conteúdo compartilhado com outros usuários ou quando a lei exigir.',
      contentResponsibilityTitle: '4.2 Responsabilidade pelo Conteúdo',
      contentResponsibilityIntro: 'Você é o único responsável pelo seu Conteúdo do Usuário. Você declara e garante que:',
      contentResponsibility1: 'Você é titular ou possui os direitos necessários sobre todo o Conteúdo do Usuário que envia',
      contentResponsibility2: 'Seu Conteúdo do Usuário não viola direitos de terceiros (direitos autorais, marcas, privacidade etc.)',
      contentResponsibility3: 'Seu Conteúdo do Usuário está em conformidade com estes Termos e com as leis aplicáveis',
      contentProhibitedTitle: '4.3 Conteúdo Proibido',
      contentProhibitedIntro: 'Você não pode enviar, armazenar ou compartilhar conteúdo que:',
      contentProhibited1: 'Seja ilegal, prejudicial, ameaçador, abusivo, assediador, difamatório ou de ódio',
      contentProhibited2: 'Infrinja direitos de propriedade intelectual ou outros direitos de propriedade',
      contentProhibited3: 'Contenha malware, vírus ou outro código nocivo',
      contentProhibited4: 'Viole direitos de privacidade ou contenha informações pessoais não autorizadas',
      contentProhibited5: 'Promova atividades ilegais ou violência',
      contentProhibited6: 'Contenha material de abuso sexual infantil ou explore menores',
      contentProhibited7: 'Constitua spam ou conteúdo comercial não solicitado',
      contentOurRightsTitle: '4.4 Nossos Direitos',
      contentOurRightsBody: 'O Yarnboard e seus licenciadores mantêm todos os direitos, títulos e interesses sobre o Serviço, incluindo todo o software, tecnologia, designs e marcas. Estes Termos não concedem a você qualquer direito de usar a propriedade intelectual do Yarnboard, exceto no que for necessário para usar o Serviço.',
      acceptableUseIntro: 'Você concorda em não:',
      acceptableUse1: 'Usar o Serviço para qualquer finalidade ilegal ou em violação de qualquer lei',
      acceptableUse2: 'Tentar obter acesso não autorizado ao Serviço ou às contas de outros usuários',
      acceptableUse3: 'Interferir no Serviço ou nos servidores, ou interrompê-los',
      acceptableUse4: 'Usar sistemas automatizados (bots, scrapers) sem permissão',
      acceptableUse5: 'Fazer engenharia reversa, descompilar ou desmontar qualquer parte do Serviço',
      acceptableUse6: 'Remover ou modificar avisos de direitos autorais, de marcas ou de propriedade',
      acceptableUse7: 'Fazer-se passar por qualquer pessoa ou entidade ou declarar falsamente sua afiliação',
      acceptableUse8: 'Coletar ou extrair informações sobre outros usuários',
      acceptableUse9: 'Usar o Serviço para enviar spam ou mensagens não solicitadas',
      acceptableUse10: 'Sobrecarregar ou tentar saturar nossa infraestrutura',
      paymentPricingTitle: '6.1 Preços',
      paymentPricingBody: 'Certos recursos ou planos do Serviço podem exigir pagamento. Todos os valores são em dólares norte-americanos, salvo indicação em contrário. Reservamo-nos o direito de alterar nossos preços com 30 dias de aviso prévio.',
      paymentBillingTitle: '6.2 Cobrança',
      paymentBillingIntro: 'Se você contratar uma assinatura:',
      paymentBilling1: 'Você nos autoriza a cobrar seu meio de pagamento de forma recorrente',
      paymentBilling2: 'As assinaturas são renovadas automaticamente, a menos que sejam canceladas antes da data de renovação',
      paymentBilling3: 'Você é responsável por todas as cobranças geradas na sua conta',
      paymentBilling4: 'Os reembolsos são concedidos apenas quando exigidos por lei ou a nosso critério',
      paymentCancellationTitle: '6.3 Cancelamento',
      paymentCancellationBody: 'Você pode cancelar sua assinatura a qualquer momento nas configurações da conta. O cancelamento passa a valer no fim do período de cobrança atual. Não há reembolsos parciais pelo tempo não utilizado.',
      privacyBody: 'Seu uso do Serviço está sujeito à nossa Política de Privacidade, que explica como coletamos, usamos e protegemos suas informações pessoais. Ao usar o Serviço, você consente com nossas práticas de dados descritas na Política de Privacidade.',
      privacyGdpr: '**Conformidade com o GDPR:** Para usuários da União Europeia, cumprimos o Regulamento Geral de Proteção de Dados (GDPR). Você tem direitos de acesso, retificação, exclusão, portabilidade de dados e oposição em relação aos seus dados pessoais.',
      disclaimersAsIsTitle: '8.1 Serviço "No Estado em Que Se Encontra"',
      disclaimersAsIsBody: 'O SERVIÇO É FORNECIDO "NO ESTADO EM QUE SE ENCONTRA" E "CONFORME DISPONÍVEL", SEM GARANTIAS DE QUALQUER TIPO, EXPRESSAS OU IMPLÍCITAS, INCLUINDO, ENTRE OUTRAS, GARANTIAS DE COMERCIABILIDADE, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA, NÃO VIOLAÇÃO OU EXATIDÃO.',
      disclaimersNoWarrantyIntro: 'Não garantimos que:',
      disclaimersNoWarranty1: 'O Serviço será ininterrupto, seguro ou livre de erros',
      disclaimersNoWarranty2: 'O conteúdo será preciso, completo ou confiável',
      disclaimersNoWarranty3: 'Os defeitos serão corrigidos',
      disclaimersNoWarranty4: 'O Serviço está livre de vírus ou componentes nocivos',
      disclaimersLiabilityTitle: '8.2 Limitação de Responsabilidade',
      disclaimersLiabilityP1: 'NA MÁXIMA EXTENSÃO PERMITIDA POR LEI, O YARNBOARD NÃO SERÁ RESPONSÁVEL POR QUAISQUER DANOS INDIRETOS, INCIDENTAIS, ESPECIAIS, CONSEQUENCIAIS OU PUNITIVOS, INCLUINDO, ENTRE OUTROS, PERDA DE DADOS, PERDA DE LUCROS OU INTERRUPÇÃO DE NEGÓCIOS, DECORRENTES DO SEU USO OU DA IMPOSSIBILIDADE DE USAR O SERVIÇO OU RELACIONADOS A ELES.',
      disclaimersLiabilityP2: 'NAS JURISDIÇÕES QUE NÃO PERMITEM A LIMITAÇÃO DE RESPONSABILIDADE, NOSSA RESPONSABILIDADE É LIMITADA À MÁXIMA EXTENSÃO PERMITIDA POR LEI. EM NENHUMA HIPÓTESE NOSSA RESPONSABILIDADE TOTAL EXCEDERÁ O VALOR QUE VOCÊ NOS PAGOU NOS 12 MESES ANTERIORES À RECLAMAÇÃO, OU US$ 100, O QUE FOR MAIOR.',
      disclaimersBackupTitle: '8.3 Responsabilidade pelo Backup',
      disclaimersBackupBody: 'Embora mantenhamos sistemas de backup, você é responsável por manter seus próprios backups do conteúdo importante. Não somos responsáveis por qualquer perda ou corrupção dos seus dados.',
      indemnificationIntro: 'Você concorda em indenizar, defender e isentar o Yarnboard, seus diretores, conselheiros, funcionários e agentes de quaisquer reivindicações, responsabilidades, danos, perdas, custos ou despesas (incluindo honorários advocatícios razoáveis) decorrentes de:',
      indemnification1: 'Seu uso ou uso indevido do Serviço',
      indemnification2: 'Sua violação destes Termos',
      indemnification3: 'Sua violação de direitos de terceiros',
      indemnification4: 'Seu Conteúdo do Usuário',
      thirdPartyBody: 'O Serviço pode se integrar a serviços, sites ou conteúdos de terceiros, ou direcionar a eles. Não controlamos nem somos responsáveis por serviços de terceiros. O uso de serviços de terceiros é por sua conta e risco e está sujeito aos termos e políticas deles.',
      copyrightIntro: 'Respeitamos os direitos de propriedade intelectual. Se você acredita que algum conteúdo no Yarnboard viola seus direitos autorais, entre em contato conosco informando:',
      copyright1: 'A identificação da obra protegida por direitos autorais',
      copyright2: 'A identificação do material infrator e sua localização',
      copyright3: 'Suas informações de contato',
      copyright4: 'Uma declaração de boa-fé de que o uso não está autorizado',
      copyright5: 'Uma declaração de que as informações são precisas e de que você está autorizado a agir',
      copyright6: 'Sua assinatura física ou eletrônica',
      copyrightOutro: 'Responderemos a notificações válidas apresentadas sob a DMCA e podemos encerrar contas de infratores reincidentes.',
      disputesInformalTitle: '12.1 Resolução Informal',
      disputesInformalBody: 'Antes de iniciar um procedimento formal, você concorda em entrar em contato conosco para tentar resolver qualquer disputa de forma informal.',
      disputesArbitrationTitle: '12.2 Arbitragem (Usuários dos EUA)',
      disputesArbitrationBody: 'Para usuários nos Estados Unidos, qualquer disputa decorrente destes Termos ou do Serviço será resolvida por arbitragem vinculante, conforme as regras da American Arbitration Association, exceto onde a lei proibir.',
      disputesEuTitle: '12.3 Usuários da UE',
      disputesEuBody: 'Para usuários da União Europeia, as disputas podem ser submetidas aos tribunais competentes do seu país de residência. Os consumidores da UE também podem usar a plataforma de Resolução de Litígios em Linha da Comissão Europeia em: https://ec.europa.eu/consumers/odr',
      disputesClassActionTitle: '12.4 Renúncia a Ações Coletivas',
      disputesClassActionBody: 'Na medida permitida por lei, você concorda que as disputas serão resolvidas individualmente e renuncia ao direito de participar de ações coletivas ou de arbitragem coletiva.',
      governingBody: 'Estes Termos são regidos pelas leis da Costa Rica, sem considerar princípios de conflito de leis. Para usuários da UE, aplicam-se, quando cabível, as normas imperativas de proteção ao consumidor do seu país de residência.',
      modificationsP1: 'Podemos modificar estes Termos a qualquer momento publicando os Termos atualizados em nosso site. Alterações relevantes serão comunicadas por e-mail ou pelo Serviço com pelo menos 30 dias de antecedência da entrada em vigor. O uso continuado após as alterações constitui aceitação dos Termos modificados.',
      modificationsP2: 'Se você não concordar com os Termos modificados, deve parar de usar o Serviço e pode encerrar sua conta.',
      severabilityBody: 'Se qualquer disposição destes Termos for considerada inválida ou inexequível, as demais disposições permanecerão em pleno vigor. O fato de não exercermos qualquer direito ou disposição não constitui renúncia a esse direito ou disposição.',
      entireBody: 'Estes Termos, juntamente com nossa Política de Privacidade, constituem o acordo integral entre você e o Yarnboard em relação ao Serviço e substituem todos os acordos e entendimentos anteriores.',
      contactIntro: 'Para dúvidas sobre estes Termos ou sobre o Serviço, entre em contato conosco:',
      contactEmail: '**E-mail:** legal@yarnboard.com',
      contactSupport: '**Suporte:** support@yarnboard.com',
      contactLocation: '**Localização:** Costa Rica',
      euIntro: 'Além dos termos acima, as seguintes disposições se aplicam aos usuários da União Europeia:',
      euWithdrawal: '**Direito de Arrependimento:** Você tem 14 dias para desistir de uma compra sem precisar justificar',
      euGuarantees: '**Garantias do Consumidor:** O conteúdo digital deve corresponder à descrição e ser adequado à sua finalidade',
      euUnfair: '**Cláusulas Abusivas:** Cláusulas contratuais abusivas não vinculam os consumidores da UE',
      euDataProtection: '**Proteção de Dados:** Estes Termos não podem afastar seus direitos sob o GDPR',
    },
    auth: {
      loginTitle: 'Entrar',
      emailLabel: 'E-mail:',
      passwordLabel: 'Senha:',
      loggingIn: 'Entrando...',
      loginButton: 'Entrar',
      invalidCredentials: 'Usu\u00e1rio ou senha inv\u00e1lidos',
      noAccount: 'N\u00e3o tem conta? ',
      registerHere: 'Cadastre-se aqui',
      registerTitle: 'Cadastrar',
      emailField: 'E-mail',
      passwordField: 'Senha',
      confirmPasswordField: 'Confirmar Senha',
      usernameOptional: 'Usu\u00e1rio (opcional)',
      registering: 'Cadastrando...',
      registerButton: 'Cadastrar',
      haveAccount: 'J\u00e1 tem conta? ',
      loginHere: 'Entre aqui',
      invalidEmail: 'Digite um e-mail v\u00e1lido',
      passwordsDoNotMatch: 'As senhas n\u00e3o conferem',
      passwordTooShort: 'A senha precisa ter pelo menos 8 caracteres',
      emailErrorPrefix: 'E-mail: {message}',
      passwordErrorPrefix: 'Senha: {message}',
      registrationFailed: 'N\u00e3o foi poss\u00edvel concluir o cadastro. Tente de novo.',
      orDivider: 'ou',
      googleLoadFailed: 'N\u00e3o foi poss\u00edvel carregar o login com o Google',
      googleSignInFailed: 'O login com o Google falhou',
      handoffMissingCode: 'Falta o c\u00f3digo neste link de acesso.',
      handoffInvalid: 'Este link de acesso \u00e9 inv\u00e1lido ou expirou. Tente de novo pelo app.',
      handoffFailedTitle: 'N\u00e3o conseguimos te conectar',
      handoffLogIn: 'Entrar',
      handoffSigningIn: 'Conectando voc\u00ea\u2026',
    },
  },
};
